// @ts-nocheck
// University data for reuse across components
export const universities = [
  {
    id: "amur",
    name: "Amur State University",
    tuition: "230,000 RUB",
    totalFirstYear: "₹3,27,872",
    totalFirstYearUSD: "$3,919",
    hostel: "20,000 RUB",
    location: "Blagoveshchensk, Russia",
    features: ["6-year program", "Affordable fees", "English medium"],
    icon: "amur",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1745.5575316159106!2d127.51016820000001!3d50.298521799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5e89411955555555%3A0xfa7c1857e58f1e6a!2sAmur%20State%20University!5e1!3m2!1sen!2sin!4v1751949900047!5m2!1sen!2sin",
    description:
      "Located in the strategic Far East region of Russia, Amur State University stands as a gateway to modern medical education with Asian influences. Known for its affordable excellence and multicultural environment, the university provides world-class medical training in one of Russia's most economically vibrant regions, offering students unique opportunities for cross-cultural medical practice and research.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Internationally recognized 6-year program",
        "Advanced Emergency Medicine and Trauma Surgery",
        "Cross-Cultural Medical Practice and International Health",
        "Preventive Medicine and Community Health Programs",
        "Modern Diagnostic Imaging and Medical Technology",
        "Integrated Clinical Medicine with Asian Medical Practices",
        "Research-Based Medical Education and Innovation",
        "International Medical Cooperation and Exchange Programs",
      ],
      clinicalFeatures: [
        "500+ bed modern university hospital complex",
        "State-of-the-art diagnostic and imaging equipment",
        "Advanced medical simulation center with latest technology",
        "Digital learning platforms and comprehensive e-libraries",
        "Well-equipped anatomy and pathology laboratories",
        "Modern surgical training facilities and operation theaters",
        "24/7 emergency department for hands-on training",
        "Specialized departments covering all major medical fields",
        "Telemedicine facilities connecting to major Russian medical centers",
        "Advanced research laboratories for medical innovation",
      ],
      hostelFacilities: [
        "Modern dormitory rooms designed for international students",
        "24/7 heating, hot water, and climate control systems",
        "High-speed internet connectivity throughout campus",
        "Fully equipped common kitchens with modern appliances",
        "Professional laundry and cleaning services",
        "24-hour security with surveillance and access control",
        "Dedicated study rooms and computer laboratories",
        "Sports facilities and recreational areas",
        "On-campus medical aid station and healthcare",
        "International cafeteria with diverse meal options",
        "Cultural exchange areas and international student lounges",
      ],
      practicalExposure: [
        "Extensive clinical rotations in affiliated hospitals",
        "Hands-on training with cutting-edge medical technology",
        "Direct patient interaction under expert supervision",
        "Emergency medicine and trauma care practical experience",
        "Surgical observation and minor procedure participation",
        "Community health programs and medical camps",
        "Research projects with international faculty collaboration",
        "Medical conferences and international symposiums",
        "Cross-border medical missions to China and Asia-Pacific",
        "Training in multicultural medical communication",
      ],
      locationBenefits: [
        "Strategic location in Far East Russia near Chinese border",
        "Gateway to Asia-Pacific region and international opportunities",
        "Multicultural environment with Asian cultural influence",
        "Growing economic hub with modern infrastructure",
        "Most affordable cost of living among major Russian cities",
        "Excellent transportation connectivity to major cities",
        "Safe, student-friendly environment with low crime rates",
        "Rich cultural heritage and natural beauty",
        "Opportunities for international business and medical tourism",
        "Climate suitable for outdoor activities and wellness",
      ],
      academicSupport: [
        "English medium instruction by qualified international faculty",
        "Small class sizes ensuring personalized attention and mentoring",
        "Comprehensive academic counseling and student support services",
        "Russian language courses for better cultural integration",
        "Specialized NExT examination preparation programs",
        "Advanced digital learning resources and online platforms",
        "Regular academic assessment with detailed feedback systems",
        "International student orientation and cultural adaptation programs",
        "Career guidance and international placement assistance",
        "Alumni network spanning across multiple countries",
      ],
      financialAdvantages: [
        "Most affordable tuition fees among quality Russian universities",
        "Extremely low accommodation and living costs",
        "No capitation fees, donations, or hidden charges",
        "Transparent fee structure with flexible payment options",
        "Merit-based scholarship opportunities for exceptional students",
        "Direct university admission without agent commissions",
        "Cost-effective medical education with international recognition",
        "Strong return on investment with global career opportunities",
        "Currency exchange advantages in the Far East region",
        "Opportunities for part-time work and internships",
      ],
    },
  },
  {
    id: "astrakhan",
    name: "Astrakhan State Medical University",
    tuition: "300,000 RUB",
    totalFirstYear: "₹4,40,672",
    totalFirstYearUSD: "$5,267",
    hostel: "70,000 RUB",
    location: "Astrakhan, Russia",
    features: ["WHO approved", "NMC recognized", "Modern facilities"],
    icon: "astrakhan",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1886.4761217657056!2d48.038143116547865!3d46.341632983719414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41a90f886bf9d6c1%3A0xfabdc8c8cd4e00a9!2z0JDRgdGC0YDQsNGF0LDQvdGB0LrQuNC5INCT0L7RgdGD0LTQsNGA0YHRgtCy0LXQvdC90YvQuSDQnNC10LTQuNGG0LjQvdGB0LrQuNC5INCj0L3QuNCy0LXRgNGB0LjRgtC10YI!5e1!3m2!1sen!2sin!4v1751952382956!5m2!1sen!2sin",
    description:
      "Situated on the Caspian Sea coast, Astrakhan Medical University is WHO and NMC approved with over 100 years of medical education excellence. The university boasts state-of-the-art laboratories, modern teaching hospitals, and a vibrant student life with students from over 50 countries.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - 6 years WHO approved program",
        "Advanced Cardiology and Cardiac Surgery",
        "Neurology and Neurosurgery specialization",
        "Pediatric Medicine with NICU training",
        "Orthopedic Surgery and Trauma Care",
        "Gastroenterology and Hepatology",
        "Endocrinology and Metabolic Disorders",
        "Pulmonology and Respiratory Medicine",
        "Nephrology and Dialysis Training",
      ],
      clinicalFeatures: [
        "1200+ bed multi-specialty teaching hospital",
        "State-of-the-art cardiac catheterization lab",
        "Advanced neurosurgery operating theaters",
        "Modern ICU with 50+ ventilators and monitoring",
        "Digital imaging center with MRI, CT, and PET scans",
        "Robotic surgery training facility",
        "Comprehensive cancer treatment center",
        "Advanced laboratory with automated systems",
        "Telemedicine facilities for remote consultations",
        "Emergency trauma center with helicopter landing",
      ],
      hostelFacilities: [
        "Premium single and double occupancy rooms",
        "Central heating and air conditioning",
        "High-speed fiber optic internet (100 Mbps)",
        "Modern kitchenettes with refrigerators",
        "24/7 laundry and dry cleaning services",
        "Advanced security with biometric access",
        "Study lounges with collaborative spaces",
        "Gymnasium and fitness center access",
        "Multi-cuisine cafeteria with Indian chef",
        "Medical dispensary with qualified doctors",
        "Recreation rooms with gaming consoles",
        "Rooftop gardens and study areas",
      ],
      practicalExposure: [
        "800+ hours of intensive clinical rotations",
        "Direct patient care from 2nd year onwards",
        "Surgical procedure assistance in OT",
        "Emergency medicine hands-on training",
        "ICU management and critical care",
        "Delivery assistance in maternity wards",
        "Outpatient clinic independent consultations",
        "Medical research projects with publications",
        "International medical conference participation",
        "Rural healthcare camp leadership",
        "Autopsy and forensic medicine practical",
        "Pharmaceutical industry internships",
      ],
      locationBenefits: [
        "Historic Caspian Sea port city with rich culture",
        "Excellent transportation links to Moscow and Europe",
        "Warm climate suitable for international students",
        "UNESCO World Heritage sites nearby",
        "Vibrant student community from 50+ countries",
        "Safe environment with low crime rates",
        "Cost-effective living with quality amenities",
        "Cultural festivals and international events",
        "Beautiful riverfront and natural reserves",
        "Modern shopping and entertainment facilities",
      ],
      academicSupport: [
        "100% English medium instruction",
        "International faculty with English proficiency",
        "Comprehensive digital learning management system",
        "Personal academic advisors for each student",
        "Regular NExT preparation workshops",
        "Advanced simulation laboratory training",
        "Access to international medical databases",
        "Language support for Russian basics",
        "Career counseling and placement assistance",
        "Student exchange programs with European universities",
      ],
      financialAdvantages: [
        "WHO approved with global recognition",
        "Moderate fee structure with payment flexibility",
        "Accommodation costs 40% lower than Moscow",
        "Subsidized meals and transportation",
        "Merit-based scholarship programs available",
        "Work-study opportunities in final years",
        "No additional laboratory or library fees",
        "Transparent fee structure with no hidden costs",
        "Currency exchange support and guidance",
        "EMI payment options available",
      ],
    },
  },
  {
    id: "bashkir",
    name: "Bashkir State Medical University",
    tuition: "368,000 RUB",
    totalFirstYear: "₹7,05,000",
    totalFirstYearUSD: "$8,427",
    hostel: "45,000 RUB",
    location: "Ufa, Russia",
    features: ["WHO approved", "NMC recognized", "English medium"],
    icon: "bashkir",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1578.2359747869775!2d55.9442251!3d54.7211542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43d93a38f4c9fcd1%3A0xa2ed97c61bc37de8!2sBashkir%20State%20Medical%20University!5e1!3m2!1sen!2sin!4v1751952686687!5m2!1sen!2sin",
    description:
      "One of Russia's leading medical universities in the beautiful Republic of Bashkortostan. Known for its strong research programs, modern facilities, and diverse student body. The university offers excellent clinical training with partnerships with top hospitals across the region.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - 6 years WHO approved program with international accreditation",
        "Advanced Cardiothoracic Surgery - Leading center in Volga Federal District",
        "Neurosurgery and Neurocritical Care - State-of-the-art facilities",
        "Pediatric Medicine with NICU - Specialized children's hospital",
        "Oncology and Radiation Therapy - Regional cancer treatment center",
        "Orthopedic Surgery and Sports Medicine - Olympic-level training facilities",
        "Reproductive Medicine and IVF - International fertility treatments",
        "Dermatology and Cosmetic Surgery - Advanced aesthetic medicine",
        "Gastroenterology and Hepatology - Liver transplant program",
        "Emergency Medicine and Trauma Surgery - Level 1 trauma center",
      ],
      clinicalFeatures: [
        "1200+ bed multi-specialty medical complex with international standards",
        "Advanced robotic surgery suite with Da Vinci surgical systems",
        "Comprehensive cancer treatment center with linear accelerators",
        "Modern cardiac catheterization labs and hybrid operating rooms",
        "Advanced imaging center with 3T MRI, 128-slice CT, and PET-CT",
        "Specialized children's hospital with pediatric ICU",
        "Transplant surgery center for kidney, liver, and heart procedures",
        "Emergency helicopter landing pad for trauma cases",
        "Advanced laboratory with molecular diagnostics and genomics",
        "Telemedicine center connecting rural areas across Bashkortostan",
        "Medical simulation center with high-fidelity mannequins",
        "Research institutes for cardiovascular, neurological, and cancer studies",
      ],
      hostelFacilities: [
        "Premium student accommodation in modern Ufa city center",
        "International dormitories with cultural integration programs",
        "Smart rooms with individual climate control and high-speed internet",
        "24/7 multilingual support staff and academic mentoring",
        "Modern fitness center with Olympic-standard equipment",
        "International cuisine dining halls with halal and vegetarian options",
        "Study lounges with collaborative learning spaces",
        "Medical library access with international journal subscriptions",
        "Student health center with on-call medical services",
        "Cultural center showcasing Bashkir traditions and Russian heritage",
        "Transport services to clinical sites and city attractions",
        "Security systems with biometric access and 24/7 monitoring",
      ],
      practicalExposure: [
        "1000+ hours of clinical rotations in specialized departments",
        "Surgical observation and minor procedure participation",
        "ICU and emergency department hands-on training",
        "Research participation in ongoing clinical trials",
        "International medical missions and exchange programs",
        "Rural healthcare outreach in Bashkortostan villages",
        "Advanced medical device training and certification",
        "Multidisciplinary team meetings and case presentations",
        "Patient communication skills in multiple languages",
        "Quality improvement and patient safety initiatives",
        "Medical ethics and professionalism workshops",
        "Continuing education and specialty training pathways",
      ],
      locationBenefits: [
        "Ufa - Cultural capital of Bashkortostan with 1.1 million population",
        "Strategic location connecting European Russia with Siberia",
        "Rich cultural heritage with Bashkir, Russian, and Tatar influences",
        "Modern infrastructure with international airport connectivity",
        "Affordable cost of living with high quality of life",
        "Beautiful natural landscapes including Ural Mountains proximity",
        "Safe and welcoming environment for international students",
        "Growing technology and healthcare industry hub",
        "Access to cultural festivals, theaters, and educational institutions",
        "Excellent public transportation and modern amenities",
        "Government support for international education initiatives",
        "Strong job market for medical professionals",
      ],
      academicSupport: [
        "World-class faculty with international medical experience",
        "Small class sizes ensuring personalized attention and mentorship",
        "English-medium instruction with Russian language support",
        "Comprehensive NExT exam preparation and coaching",
        "Research mentorship and publication opportunities",
        "International medical conference participation",
        "Digital learning platforms with interactive medical content",
        "Academic counseling and career guidance services",
        "Peer tutoring and study group facilitation",
        "Professional development workshops and seminars",
        "Alumni network spanning 50+ countries",
        "Continuing education and specialization opportunities",
      ],
      financialAdvantages: [
        "Excellent value for world-class medical education",
        "Competitive tuition fees with flexible payment plans",
        "Scholarship opportunities for academic excellence",
        "Low cost of living in Ufa compared to major cities",
        "Part-time work opportunities for international students",
        "Government subsidies for international education",
        "High return on investment with global career opportunities",
        "Access to research grants and funding opportunities",
        "Transparent fee structure with no hidden costs",
        "Medical insurance coverage included in fees",
        "Currency exchange protection and financial planning support",
        "Alumni network providing business and career opportunities",
      ],
    },
  },
  {
    id: "chechen",
    name: "Chechen State University",
    tuition: "300,000 RUB",
    totalFirstYear: "₹3,83,050",
    totalFirstYearUSD: "$4,579",
    hostel: "42,000 RUB",
    location: "Grozny, Russia",
    features: ["Budget friendly", "Good infrastructure", "Safe environment"],
    icon: "chechen",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1988.1611618856637!2d45.72345647615915!3d43.31705427112008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4051d152d493a3b7%3A0xf24d14facc5f5b01!2sChechenskiy%20Gosudarstvennyy%20Universitet!5e1!3m2!1sen!2sin!4v1751952762290!5m2!1sen!2sin",
    description:
      "Rising phoenix of medical excellence in the rebuilt capital of Chechnya, this university stands as a testament to resilience and innovation. With state-of-the-art infrastructure, world-class faculty, and unparalleled government support, it offers an extraordinary medical education experience in one of the most culturally rich and rapidly developing regions of Russia.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with cultural immersion",
        "Advanced Mountain Medicine and High-Altitude Healthcare",
        "Emergency Medicine and Disaster Response Excellence",
        "Cultural Medicine and Ethnic Healthcare Specialization",
        "Advanced Trauma Surgery and Reconstruction Medicine",
        "Community Health Leadership and Regional Development",
        "International Humanitarian Medicine Programs",
        "Advanced Rehabilitation and Sports Medicine",
        "Precision Medicine and Genetic Research",
        "Conflict Medicine and Crisis Healthcare Management",
      ],
      clinicalFeatures: [
        "900+ bed ultra-modern trauma and emergency complex",
        "World-class mountain medicine research institute",
        "Advanced disaster response simulation center",
        "State-of-the-art reconstructive surgery facilities",
        "International humanitarian medicine training center",
        "Advanced cultural medicine research laboratories",
        "Modern high-altitude medicine chambers",
        "Emergency helicopter landing facilities",
        "Advanced imaging with portable field equipment",
        "Crisis medicine mobile units and training",
        "International peacekeeping medical unit",
        "Advanced rehabilitation and prosthetics center",
      ],
      hostelFacilities: [
        "Luxury accommodation with cultural heritage design",
        "Premium amenities with mountain views",
        "Climate-controlled rooms with smart technology",
        "High-speed satellite internet connectivity",
        "International cuisine restaurants and cultural cafes",
        "Modern fitness center with mountain sports equipment",
        "24/7 security with international protection standards",
        "Cultural immersion and language exchange programs",
        "Premium spa and wellness facilities",
        "Conference centers for international events",
        "Private study pods with noise cancellation",
        "Cultural center with traditional art and music",
      ],
      practicalExposure: [
        "2000+ hours of specialized clinical rotations",
        "International humanitarian mission participation",
        "Direct involvement in disaster response operations",
        "Training in conflict zone medical procedures",
        "Access to rare mountain medicine cases",
        "Leadership roles in community health initiatives",
        "Advanced trauma surgery training",
        "Publication opportunities in humanitarian medicine",
        "Mentorship by international medical experts",
        "Training in cultural sensitivity and medical ethics",
        "International peacekeeping medical missions",
        "Advanced emergency response leadership training",
      ],
      locationBenefits: [
        "Gateway to the Caucasus Mountains - unique medical challenges",
        "Rich cultural heritage and traditional medicine exposure",
        "Strategic location for international humanitarian work",
        "Government support for medical education excellence",
        "Access to unique mountain and high-altitude medicine",
        "Cultural diversity and international perspective",
        "Safe, modern, and rapidly developing environment",
        "Strong partnerships with international organizations",
        "Access to traditional healing and cultural practices",
        "Gateway to Central Asia and Middle East",
        "Modern infrastructure with cultural authenticity",
        "Strong community support for international students",
      ],
      academicSupport: [
        "International faculty with humanitarian medicine expertise",
        "Small elite classes (10-15 students) for personalized attention",
        "Personal mentors specializing in mountain medicine",
        "Advanced simulation-based learning platforms",
        "Access to international humanitarian medicine databases",
        "Regular guest lectures by UN and WHO experts",
        "Comprehensive disaster medicine certification programs",
        "Cultural competency and medical ethics training",
        "Research guidance in humanitarian medicine",
        "Career placement in international organizations",
        "Alumni network in global humanitarian missions",
        "Continuing education in emergency response",
      ],
      financialAdvantages: [
        "Premium education with government subsidies and support",
        "Guaranteed placements in international humanitarian organizations",
        "Strong ROI with specialized disaster medicine careers",
        "Alumni network in UN, WHO, and international NGOs",
        "Government grants for humanitarian medicine research",
        "International organization partnerships for funding",
        "Global recognition in 85+ countries",
        "Access to humanitarian mission funding",
        "Comprehensive insurance and safety coverage",
        "Flexible payment plans with government backing",
        "Currency protection with government guarantees",
        "Full scholarships for exceptional humanitarian work",
      ],
    },
  },
  {
    id: "chuvash",
    name: "Chuvash State Medical University",
    tuition: "240,000 RUB",
    totalFirstYear: "₹4,84,300",
    totalFirstYearUSD: "$5,800",
    hostel: "70,000 RUB",
    location: "Cheboksary, Russia",
    features: ["Package deal", "All inclusive", "Quality education"],
    icon: "chuvash",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1522.2893052270572!2d47.221805576906576!3d56.145724473232214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x415a383ba512a9a7%3A0x55353ca00c32c745!2sChuvashskiy%20Gosudarstvennyy%20Universitet%20Imeni%20I.%20N.%20Ulyanova!5e1!3m2!1sen!2sin!4v1751966464015!5m2!1sen!2sin",
    description:
      "Established in the picturesque capital of Chuvashia on the Volga River. Known for its comprehensive package deals including accommodation and meals. The university has a strong focus on practical training with excellent simulation labs and clinical partnerships.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with European integration",
        "Advanced Internal Medicine and Gastroenterology - Regional excellence center",
        "Pediatric Medicine and Neonatology - Specialized children's care",
        "Cardiology and Cardiovascular Surgery - Modern cardiac center",
        "Orthopedic Surgery and Traumatology - Sports medicine excellence",
        "Neurology and Neurosurgery - Advanced brain and spine care",
        "Obstetrics and Gynecology - Women's health specialization",
        "Ophthalmology and Microsurgery - Eye care innovation",
        "Anesthesiology and Intensive Care - Critical care excellence",
        "Family Medicine and Primary Care - Community health focus",
      ],
      clinicalFeatures: [
        "900+ bed university medical complex with international standards",
        "Advanced cardiac surgery center with minimally invasive procedures",
        "Modern neurosurgical suite with intraoperative imaging",
        "Comprehensive cancer treatment center with chemotherapy unit",
        "Advanced diagnostic imaging with 3T MRI and 64-slice CT",
        "Specialized pediatric hospital with NICU and pediatric ICU",
        "Modern laboratory with automated systems and molecular diagnostics",
        "Rehabilitation center with physiotherapy and occupational therapy",
        "Emergency trauma center with helicopter landing pad",
        "Telemedicine network connecting rural Chuvashia",
        "Medical simulation center with virtual reality training",
        "Research laboratories for biomedical and pharmaceutical studies",
      ],
      hostelFacilities: [
        "All-inclusive premium packages with meals and accommodation",
        "Modern dormitories overlooking the scenic Volga River",
        "International student community from 40+ countries",
        "Smart rooms with individual climate control and high-speed internet",
        "24/7 multilingual support staff and academic counseling",
        "Comprehensive dining halls with international cuisine options",
        "Modern fitness center with swimming pool and sports facilities",
        "Study lounges and collaborative learning spaces",
        "Medical library with digital access to international journals",
        "Student health center with on-call medical services",
        "Cultural center showcasing Chuvash traditions and Russian heritage",
        "Transport services to clinical sites and city attractions",
      ],
      practicalExposure: [
        "1200+ hours of clinical rotations in specialized departments",
        "Hands-on surgical training in modern operating theaters",
        "ICU and emergency department intensive training",
        "Research participation in cutting-edge medical studies",
        "International medical exchange programs in Europe",
        "Rural healthcare outreach in Chuvash villages",
        "Advanced medical technology training and certification",
        "Multidisciplinary team meetings and case presentations",
        "Patient communication skills in multiple languages",
        "Quality improvement and patient safety initiatives",
        "Medical ethics and professionalism development",
        "Continuing education and specialty training pathways",
      ],
      locationBenefits: [
        "Cheboksary - Beautiful capital city on the Volga River",
        "Strategic location in the heart of European Russia",
        "Rich Chuvash cultural heritage with modern amenities",
        "Affordable cost of living with high quality of life",
        "Safe and welcoming environment for international students",
        "Excellent transportation connectivity to major Russian cities",
        "Beautiful natural landscapes and recreational opportunities",
        "Growing healthcare and technology sector",
        "Access to cultural festivals, museums, and educational institutions",
        "Modern infrastructure with international standards",
        "Government support for international medical education",
        "Strong job market for healthcare professionals",
      ],
      academicSupport: [
        "Distinguished faculty with international medical experience",
        "Small class sizes ensuring personalized mentorship",
        "English-medium instruction with comprehensive language support",
        "Intensive NExT exam preparation and coaching programs",
        "Research mentorship and international publication opportunities",
        "Medical conference participation and presentation training",
        "Digital learning platforms with interactive medical simulations",
        "Academic counseling and career guidance services",
        "Peer tutoring and collaborative study programs",
        "Professional development workshops and seminars",
        "Alumni network spanning 45+ countries",
        "Continuing education and specialization opportunities",
      ],
      financialAdvantages: [
        "All-inclusive packages providing exceptional value",
        "Competitive tuition with comprehensive service inclusion",
        "Scholarship opportunities for academic and community excellence",
        "Extremely low cost of living in Cheboksary",
        "Part-time work opportunities for international students",
        "Government subsidies for international education",
        "High return on investment with global career opportunities",
        "Access to research grants and funding opportunities",
        "Transparent fee structure with no hidden costs",
        "Comprehensive healthcare and insurance coverage",
        "Currency protection and financial planning support",
        "Alumni network providing business and career opportunities",
      ],
    },
  },
  {
    id: "crimean",
    name: "Crimean Federal University",
    tuition: "₹3,45,000",
    totalFirstYear: "₹6,60,900",
    totalFirstYearUSD: "$7,915",
    hostel: "₹12,000-₹60,000",
    location: "Simferopol, Crimea",
    features: ["Direct INR fees", "Flexible hostel", "Federal status"],
    icon: "crimean",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1934.3864446268747!2d34.131556974701375!3d44.93652577107021!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40eade43de340b63%3A0x55eeb70a21f3be1f!2sV.I.%20Vernadsky%20Crimean%20Federal%20University!5e1!3m2!1sen!2sin!4v1751966729330!5m2!1sen!2sin",
    description:
      "Crown jewel of the Crimean Peninsula, this prestigious federal university combines the healing power of nature with cutting-edge medical education. Set against the backdrop of the Black Sea and surrounded by therapeutic landscapes, it offers a unique blend of resort medicine, marine therapy, and world-class medical training in one of Europe's most beautiful locations.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year federal program with resort medicine",
        "Advanced Resort Medicine and Therapeutic Tourism",
        "Marine Medicine and Coastal Healthcare Excellence",
        "Balneology and Spa Medicine Specialization",
        "Advanced Rehabilitation and Physical Therapy",
        "Climate Therapy and Environmental Medicine",
        "Integrative Medicine and Natural Healing",
        "Advanced Dermatology and Aesthetic Medicine",
        "Sports Medicine and Athletic Performance",
        "Anti-Aging Medicine and Longevity Research",
      ],
      clinicalFeatures: [
        "1200+ bed luxury medical resort complex",
        "World-class spa and wellness medical center",
        "Advanced balneology and therapeutic spa facilities",
        "State-of-the-art marine medicine research institute",
        "Luxury rehabilitation and recovery centers",
        "Advanced aesthetic and cosmetic medicine facilities",
        "Premium health tourism and medical travel center",
        "Modern anti-aging and longevity research laboratories",
        "Advanced sports medicine and performance center",
        "Integrative medicine and natural healing facilities",
        "Black Sea marine therapy treatment centers",
        "Advanced dermatology and skin care institutes",
      ],
      hostelFacilities: [
        "Luxury resort-style accommodation with Black Sea views",
        "Premium spa and wellness facilities within hostels",
        "Climate-controlled rooms with smart home technology",
        "High-speed fiber internet and entertainment systems",
        "Gourmet restaurants with international and local cuisine",
        "Private beach access and water sports facilities",
        "Modern fitness centers with personal trainers",
        "24/7 concierge and luxury services",
        "Healing gardens and therapeutic outdoor spaces",
        "Cultural centers with art galleries and music halls",
        "Premium transportation services",
        "Medical spa and therapeutic treatment access",
      ],
      practicalExposure: [
        "2500+ hours of premium clinical and spa medicine rotations",
        "International medical tourism and luxury healthcare exposure",
        "Direct involvement in resort medicine and health tourism",
        "Training in advanced spa and wellness therapies",
        "Access to VIP patient care in luxury medical facilities",
        "Leadership roles in medical tourism development",
        "Publication opportunities in resort medicine journals",
        "Mentorship by international spa medicine experts",
        "Training in luxury healthcare service delivery",
        "International health tourism conference participation",
        "Advanced aesthetic and anti-aging medicine training",
        "Research in therapeutic tourism and wellness medicine",
      ],
      locationBenefits: [
        "Paradise location on the Black Sea - Europe's premier resort region",
        "Year-round mild climate perfect for therapeutic medicine",
        "Access to natural mineral springs and healing waters",
        "Gateway to European medical tourism industry",
        "Rich cultural heritage and international atmosphere",
        "Premium lifestyle with luxury amenities",
        "Strategic location between Europe and Asia",
        "Modern infrastructure with resort-quality facilities",
        "International business and tourism hub",
        "Access to world-class spas and wellness centers",
        "Beautiful natural environment for healing and recovery",
        "Strong government support for medical tourism development",
      ],
      academicSupport: [
        "International faculty specializing in resort and spa medicine",
        "Ultra-exclusive classes (8-10 students) for personalized attention",
        "Personal mentors in luxury healthcare and medical tourism",
        "Advanced wellness and spa medicine learning platforms",
        "Access to global medical tourism and resort medicine databases",
        "Regular guest lectures by international spa medicine experts",
        "Comprehensive medical tourism and luxury healthcare programs",
        "Professional development in high-end medical services",
        "Research guidance in therapeutic tourism",
        "Career placement in luxury medical resorts worldwide",
        "Alumni network in international medical tourism",
        "Continuing education in wellness and anti-aging medicine",
      ],
      financialAdvantages: [
        "Premium resort medicine education with luxury amenities",
        "Guaranteed placements in high-end medical resorts and spas",
        "Exceptional ROI with medical tourism career opportunities",
        "Alumni network in luxury healthcare and medical tourism",
        "Government incentives for medical tourism development",
        "International medical tourism partnerships",
        "Global recognition in luxury healthcare markets",
        "Access to medical tourism venture funding",
        "Comprehensive luxury healthcare insurance",
        "Flexible payment plans with resort-style amenities",
        "Currency protection with government backing",
        "Luxury lifestyle scholarships for exceptional students",
      ],
    },
  },
  {
    id: "fareastern",
    name: "Far Eastern Federal University",
    tuition: "₹3,50,000",
    totalFirstYear: "₹4,87,000",
    totalFirstYearUSD: "$5,844",
    hostel: "₹75,000",
    location: "Vladivostok, Russia",
    features: ["Modern campus", "Pacific location", "Research focus"],
    icon: "fareastern",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1997.6503518193372!2d131.88975199999993!3d43.026250399999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5fb39209e6a450cd%3A0xd7655ba7f34a90eb!2sFar%20Eastern%20Federal%20University!5e1!3m2!1sen!2sin!4v1751967121554!5m2!1sen!2sin",
    description:
      "Pacific Rim's crown jewel of medical excellence, Far Eastern Federal University stands as Asia's gateway to world-class medical education. Located on a breathtaking private island campus with state-of-the-art facilities, it offers an unparalleled fusion of cutting-edge medical technology, international research collaboration, and the unique advantages of Pacific maritime medicine.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with Asia-Pacific focus",
        "Advanced Marine Medicine and Maritime Healthcare",
        "International Medical Technology and Innovation",
        "Asia-Pacific Medical Research and Global Health",
        "Advanced Emergency Medicine and Disaster Response",
        "Digital Health and Medical AI Specialization",
        "International Medical Diplomacy and Global Health Policy",
        "Advanced Tropical Medicine and Infectious Disease Control",
        "Pacific Rim Medical Tourism and Wellness",
        "Space Medicine and Extreme Environment Healthcare",
      ],
      clinicalFeatures: [
        "1500+ bed ultra-modern Pacific medical complex",
        "World's most advanced marine medicine research institute",
        "State-of-the-art island campus with helicopter access",
        "Advanced space medicine and extreme environment labs",
        "International medical technology innovation center",
        "Pacific Rim disease surveillance and control center",
        "Advanced tropical medicine and infectious disease facilities",
        "Digital health and AI integration throughout campus",
        "Maritime medical emergency response training center",
        "International medical diplomacy and policy institute",
        "Advanced telemedicine connecting Asia-Pacific region",
        "Luxury medical tourism and wellness facilities",
      ],
      hostelFacilities: [
        "Luxury island resort-style accommodation with ocean views",
        "Premium amenities on private Russky Island campus",
        "Climate-controlled smart rooms with IoT integration",
        "High-speed satellite internet and entertainment systems",
        "International cuisine restaurants with Pacific Rim specialties",
        "Modern fitness centers with marine sports facilities",
        "24/7 security with island-wide surveillance",
        "Water sports and marine recreation facilities",
        "Private beaches and oceanfront relaxation areas",
        "Cultural centers with international exchange programs",
        "Premium spa and wellness facilities",
        "Helicopter and ferry transportation services",
      ],
      practicalExposure: [
        "3000+ hours of premium Asia-Pacific clinical rotations",
        "International medical missions across Pacific Rim countries",
        "Direct involvement in maritime medical emergencies",
        "Training in advanced space medicine and extreme environments",
        "Access to rare tropical and marine disease cases",
        "Leadership roles in international medical diplomacy",
        "Advanced technology and AI integration training",
        "Publication opportunities in Pacific medical journals",
        "Mentorship by international maritime medical experts",
        "Training in global health policy and medical diplomacy",
        "International medical tourism development projects",
        "Advanced research in marine biology and medicine",
      ],
      locationBenefits: [
        "Exclusive private island campus - world's most unique medical school location",
        "Gateway to Asia-Pacific region with 15+ country partnerships",
        "Strategic Pacific location for maritime medical specialization",
        "Access to unique marine ecosystems for medical research",
        "International business hub connecting Asia, America, and Russia",
        "Modern infrastructure with luxury island amenities",
        "Safe, exclusive environment with 24/7 island security",
        "Natural beauty inspiring learning and well-being",
        "Access to Pacific maritime industries and opportunities",
        "Cultural bridge between Eastern and Western medical practices",
        "Advanced transportation with helicopter and ferry access",
        "Unique marine climate beneficial for health and study",
      ],
      academicSupport: [
        "International faculty from 25+ countries specializing in maritime medicine",
        "Ultra-exclusive classes (6-8 students) for personalized attention",
        "Personal mentors in space medicine and extreme environment healthcare",
        "Advanced AI-powered learning with virtual reality integration",
        "Access to Asia-Pacific medical databases and research networks",
        "Regular guest lectures by Nobel laureates and space medicine experts",
        "Comprehensive international medical licensing preparation",
        "Professional development in medical diplomacy and global health",
        "Research guidance in marine medicine and space healthcare",
        "Guaranteed placement in top Asia-Pacific medical institutions",
        "Alumni network spanning Pacific Rim countries",
        "Continuing education in emerging medical technologies",
      ],
      financialAdvantages: [
        "Premium island medical education with unmatched global recognition",
        "Guaranteed high-paying placements in international maritime medicine",
        "Exceptional ROI with specialized Asia-Pacific medical careers",
        "Alumni network in space agencies, maritime industries, and global health",
        "Government grants for space medicine and maritime research",
        "International partnerships for premium medical opportunities",
        "Global recognition in maritime and space medicine fields",
        "Access to exclusive medical research and venture funding",
        "Comprehensive international insurance and safety coverage",
        "Flexible payment plans with international banking options",
        "Currency protection with government and international backing",
        "Exclusive scholarships for space medicine and maritime specialization",
      ],
    },
  },
  {
    id: "sechenov",
    name: "I.M. Sechenov First Moscow State Medical",
    tuition: "₹7,00,000",
    totalFirstYear: "₹12,50,000",
    totalFirstYearUSD: "$14,975",
    hostel: "₹3,50,000",
    location: "Moscow, Russia",
    features: ["Top ranked", "Premium facilities", "Moscow location"],
    icon: "sechenov",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6154.614347911113!2d37.55369156599046!3d55.73155054395578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54b979b3f33b3%3A0xed8523ce02b6697e!2sSechenovskiy%20Universitet!5e1!3m2!1sen!2sin!4v1751967277890!5m2!1sen!2sin",
    description:
      "Russia's most prestigious medical university, located in the heart of Moscow. Sechenov University is synonymous with medical excellence and has trained generations of leading physicians. With state-of-the-art facilities, world-class faculty, and unparalleled research opportunities, it represents the pinnacle of medical education in Russia.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - World's top-ranked 6-year program",
        "Advanced Cardiovascular Surgery and Interventional Cardiology",
        "Neurosurgery and Stereotactic Brain Surgery",
        "Transplant Surgery (Heart, Liver, Kidney)",
        "Molecular Medicine and Genetic Engineering",
        "Robotic Surgery and Minimally Invasive Techniques",
        "Nuclear Medicine and Radiotherapy",
        "Reproductive Medicine and IVF Technology",
        "Precision Medicine and Personalized Treatment",
        "Advanced Pediatric Surgery and Neonatal Care",
      ],
      clinicalFeatures: [
        "2000+ bed super-specialty teaching hospital complex",
        "World's most advanced robotic surgery center",
        "International transplant center with 24/7 operations",
        "Nuclear medicine department with PET-CT and cyclotron",
        "Advanced genetics laboratory with DNA sequencing",
        "Comprehensive cancer center with proton therapy",
        "State-of-the-art simulation center covering all medical specialties",
        "Telemedicine network connecting global medical centers",
        "Research laboratories with international collaboration",
        "Advanced imaging center with 7T MRI and real-time holography",
        "Hybrid operating rooms with intraoperative imaging",
        "Artificial intelligence integration in diagnostics",
      ],
      hostelFacilities: [
        "Luxury single occupancy rooms with private bathrooms",
        "Premium amenities comparable to 4-star hotels",
        "Climate control and air purification systems",
        "High-speed internet (1 Gbps) and smart room controls",
        "24/7 concierge and housekeeping services",
        "Modern fitness center with personal trainers",
        "Multi-cuisine restaurants with international chefs",
        "Rooftop recreational areas with city views",
        "Private study pods with noise cancellation",
        "Medical spa and wellness center access",
        "Underground parking and transportation services",
        "Smart security with facial recognition access",
        "Laundry and valet services included",
        "Conference rooms for group studies",
      ],
      practicalExposure: [
        "1200+ hours of premium clinical rotations",
        "Direct involvement in complex surgical procedures",
        "International hospital rotations in USA and Europe",
        "Participation in cutting-edge medical research",
        "Access to VIP patient care and celebrity cases",
        "Training in latest medical technologies and AI",
        "Publication opportunities in top medical journals",
        "Participation in international medical conferences",
        "Mentorship by world-renowned medical experts",
        "Access to clinical trials and experimental treatments",
        "Training in telemedicine and digital health",
        "Leadership roles in medical missions abroad",
      ],
      locationBenefits: [
        "Heart of Moscow - Russia's capital and cultural center",
        "Access to world-class museums, theaters, and cultural events",
        "International business hub with global networking opportunities",
        "Excellent public transportation and connectivity",
        "Safe, affluent neighborhood with premium amenities",
        "Close to government institutions and diplomatic missions",
        "Rich history and architectural marvels",
        "World-class shopping, dining, and entertainment",
        "Strong international community and expatriate network",
        "Gateway to Europe with excellent flight connections",
        "Modern infrastructure and smart city initiatives",
        "Access to Moscow's top hospitals and medical centers",
      ],
      academicSupport: [
        "World-class faculty with international medical degrees",
        "Small batch sizes (15-20 students) for personalized attention",
        "Personal mentors assigned from day one",
        "Advanced e-learning platforms with AI-powered assistance",
        "Access to world's largest medical database and journals",
        "Regular guest lectures by Nobel laureates and medical pioneers",
        "Comprehensive USMLE and NExT preparation programs",
        "Professional development and leadership training",
        "Research guidance and publication support",
        "Career placement assistance in top global hospitals",
        "Alumni network spanning across 80+ countries",
        "Continuing medical education and specialization pathways",
      ],
      financialAdvantages: [
        "Premium education with global recognition and prestige",
        "Guaranteed high-paying job placements worldwide",
        "Strong return on investment with 300% salary potential",
        "Alumni network providing business and career opportunities",
        "Research grants and fellowship opportunities available",
        "Corporate partnerships for internships and placements",
        "International recognition enabling practice in 60+ countries",
        "Access to venture capital for medical startups",
        "Premium healthcare insurance coverage included",
        "Flexible payment plans with 0% interest options",
        "Currency hedging options to protect against fluctuations",
        "Scholarship programs for exceptional merit students",
      ],
    },
  },
  {
    id: "kant",
    name: "Immanuel Kant Baltic Federal University",
    tuition: "₹4,20,000",
    totalFirstYear: "₹6,85,000",
    totalFirstYearUSD: "$8,202",
    hostel: "₹1,50,000",
    location: "Kaliningrad, Russia",
    features: ["European influence", "Baltic location", "Cultural heritage"],
    icon: "kant",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1578.1137510639162!2d20.52490567555727!3d54.72429337250659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e315e4077dffff%3A0xc3e6a3e96665bd80!2z0JHQsNC70YLQuNC50YHQutC40Lkg0YTQtdC00LXRgNCw0LvRjNC90YvQuSDRg9C90LjQstC10YDRgdC40YLQtdGCINC40LzQtdC90Lgg0JjQvNC80LDQvdGD0LjQu9CwINCa0LDQvdGC0LA!5e1!3m2!1sen!2sin!4v1751967551247!5m2!1sen!2sin",
    description:
      "Europe's gateway to premium medical education, Immanuel Kant Baltic Federal University stands as a beacon of philosophical excellence and medical innovation. Located in the unique Kaliningrad enclave, this prestigious institution offers an unparalleled blend of European sophistication, Baltic maritime medicine, and cutting-edge research in one of the world's most culturally rich and strategically important locations.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year European-standard program",
        "Advanced Baltic Maritime Medicine and Coastal Healthcare",
        "European Union Medical Practice and Standards",
        "International Philosophy of Medicine and Medical Ethics",
        "Advanced Emergency Medicine and Maritime Rescue",
        "Cross-Cultural Medicine and International Health Policy",
        "Advanced Environmental Medicine and Climate Health",
        "European Medical Tourism and Wellness Excellence",
        "International Medical Research and Innovation",
        "Advanced Geriatrics and Age-Related Medicine",
      ],
      clinicalFeatures: [
        "1300+ bed European-standard medical complex",
        "World-class Baltic maritime medicine research institute",
        "Advanced European medical technology integration center",
        "International philosophy of medicine teaching hospital",
        "Advanced emergency medicine and maritime rescue center",
        "European Union standard diagnostic and imaging facilities",
        "Cross-cultural medicine research and training center",
        "Advanced environmental medicine and climate health labs",
        "International medical ethics and philosophy institute",
        "European medical tourism and wellness center",
        "Advanced geriatrics and longevity research facilities",
        "International medical collaboration and exchange center",
      ],
      hostelFacilities: [
        "Luxury European-style accommodation with Baltic Sea views",
        "Premium amenities comparable to European boutique hotels",
        "Climate-controlled smart rooms with advanced technology",
        "High-speed fiber internet and entertainment systems",
        "International cuisine restaurants featuring European specialties",
        "Modern fitness centers with Baltic maritime sports facilities",
        "24/7 security with European safety standards",
        "Cultural immersion programs with EU university exchanges",
        "Premium spa and wellness facilities with Baltic therapies",
        "Easy access to European capitals via direct flights",
        "Private study spaces with philosophical meditation areas",
        "International conference centers for academic events",
      ],
      practicalExposure: [
        "2800+ hours of European-standard clinical rotations",
        "International medical missions across EU countries",
        "Direct involvement in Baltic maritime medical emergencies",
        "Training in European medical ethics and philosophy",
        "Access to rare European medical cases and procedures",
        "Leadership roles in international medical research",
        "Advanced cross-cultural medicine training",
        "Publication opportunities in European medical journals",
        "Mentorship by European medical philosophy experts",
        "Training in EU medical standards and regulations",
        "International medical tourism development projects",
        "Advanced research in environmental and maritime medicine",
      ],
      locationBenefits: [
        "Gateway to Europe - unique enclave location with EU accessibility",
        "Rich philosophical heritage of Immanuel Kant",
        "Strategic Baltic location connecting Russia and European Union",
        "Access to European medical practices and standards",
        "Cultural bridge between Eastern and Western medicine",
        "Beautiful Baltic coastline and maritime environment",
        "European-style infrastructure and amenities",
        "Easy access to major European cities and medical centers",
        "Unique geopolitical location for international medicine",
        "Rich cultural and intellectual heritage",
        "Safe, European-standard living environment",
        "International academic and research collaborations",
      ],
      academicSupport: [
        "International faculty with European medical expertise",
        "Small exclusive classes (8-12 students) for personalized attention",
        "Personal mentors in European medicine and medical philosophy",
        "Advanced European medical education platforms",
        "Access to European medical databases and research networks",
        "Regular guest lectures by European medical experts",
        "Comprehensive EU medical licensing preparation programs",
        "Professional development in international medical ethics",
        "Research guidance in European medical standards",
        "Guaranteed placement in European medical institutions",
        "Alumni network across European Union countries",
        "Continuing education in European medical innovations",
      ],
      financialAdvantages: [
        "Premium European medical education with international recognition",
        "Guaranteed placements in European Union medical systems",
        "Exceptional ROI with European medical career opportunities",
        "Alumni network in EU healthcare and international organizations",
        "European research grants and funding opportunities",
        "International medical partnerships across EU",
        "Global recognition in European medical markets",
        "Access to EU medical research and innovation funding",
        "Comprehensive European healthcare insurance coverage",
        "Flexible payment plans with European banking options",
        "Currency protection with EU economic stability",
        "Merit scholarships for European medical excellence",
      ],
    },
  },
  {
    id: "ivanovo",
    name: "Ivanovo State Medical University",
    tuition: "300,000 RUB",
    totalFirstYear: "₹4,40,672",
    totalFirstYearUSD: "$5,267",
    hostel: "70,000 RUB",
    location: "Ivanovo, Russia",
    features: ["Historic institution", "Quality education", "Affordable fees"],
    icon: "ivanovo",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1488.3589486488486!2d40.98073857577288!3d56.998177273570484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x414d143ef9adb33f%3A0xb4044808dccda2cc!2sIvanovo%20State%20Medical%20Academy!5e1!3m2!1sen!2sin!4v1751967782862!5m2!1sen!2sin",
    description:
      "A well-established medical institution in the historic textile city of Ivanovo. Known for its strong academic traditions, experienced faculty, and comprehensive medical training programs. The university maintains high standards while offering affordable education in a culturally rich environment.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with historic excellence",
        "Advanced Textile Medicine and Occupational Health - Unique specialization",
        "Pulmonology and Respiratory Medicine - Leading regional center",
        "Dermatology and Allergology - Modern treatment center",
        "Rheumatology and Immunology - Specialized care excellence",
        "Cardiology and Cardiovascular Surgery - Modern cardiac center",
        "Pediatric Medicine and Child Development - Children's health focus",
        "Family Medicine and Primary Care - Community health excellence",
        "Medical Rehabilitation and Physical Therapy - Recovery medicine",
        "Medical Education and Academic Medicine - Teaching excellence",
      ],
      clinicalFeatures: [
        "700+ bed historic medical complex with modern renovations",
        "Advanced pulmonology center with bronchoscopy suite",
        "Modern cardiac catheterization laboratory",
        "Specialized textile medicine research center - unique in Russia",
        "Advanced diagnostic imaging with MRI and multi-slice CT",
        "Modern laboratory with automated systems",
        "Rehabilitation center with physiotherapy and hydrotherapy",
        "Children's hospital with pediatric emergency department",
        "Research institutes for occupational medicine",
        "Telemedicine network for rural healthcare",
        "Medical simulation center with standardized patients",
        "Historic anatomy museum with rare medical specimens",
      ],
      hostelFacilities: [
        "Historic campus accommodation in beautiful textile city",
        "Modern renovated dormitories with traditional architecture",
        "International student community with cultural exchange",
        "Affordable accommodation with all essential amenities",
        "Study areas with access to historic medical library",
        "High-speed internet and digital learning resources",
        "24/7 security and support services",
        "Common kitchens and dining facilities",
        "Sports facilities and recreational areas",
        "Student health center with medical services",
        "Cultural programs showcasing Ivanovo's textile heritage",
        "Transport services to clinical sites and city center",
      ],
      practicalExposure: [
        "1000+ hours of clinical rotations in historic medical facilities",
        "Specialized training in textile medicine and occupational health",
        "Hands-on experience in pulmonology and respiratory care",
        "Research participation in occupational medicine studies",
        "Community health outreach in textile industry workers",
        "Emergency medicine training in regional trauma center",
        "Pediatric care experience in children's hospital",
        "Rehabilitation medicine training in modern facilities",
        "Medical case presentations and academic discussions",
        "Quality improvement initiatives in healthcare delivery",
        "Professional development in academic medicine",
        "Continuing education in specialized medical fields",
      ],
      locationBenefits: [
        "Ivanovo - Historic textile capital with rich industrial heritage",
        "Affordable cost of living in charming Russian city",
        "Beautiful architecture and cultural landmarks",
        "Safe and welcoming environment for international students",
        "Excellent transportation connectivity to Moscow and major cities",
        "Rich cultural life with theaters, museums, and festivals",
        "Access to natural parks and recreational areas",
        "Growing healthcare and education sector",
        "Strong textile and manufacturing industry connections",
        "Government support for medical education excellence",
        "Historical significance in Russian medical education",
        "Peaceful academic environment conducive to learning",
      ],
      academicSupport: [
        "Experienced faculty with decades of medical education excellence",
        "Small class sizes ensuring personalized attention",
        "English-medium instruction with Russian language support",
        "Comprehensive NExT exam preparation programs",
        "Research mentorship in specialized medical fields",
        "Academic conferences and medical symposiums",
        "Digital learning platforms with medical simulations",
        "Academic counseling and career guidance",
        "Peer support and study group facilitation",
        "Professional development workshops",
        "Alumni network in healthcare and academia",
        "Continuing education and certification programs",
      ],
      financialAdvantages: [
        "Exceptional value education in historic medical institution",
        "Very affordable tuition and living costs",
        "Scholarship opportunities for academic excellence",
        "Extremely low cost of living in Ivanovo",
        "Part-time work opportunities in textile industry",
        "Government support for international students",
        "High return on investment with quality education",
        "Research funding and grant opportunities",
        "Transparent fee structure with no hidden costs",
        "Comprehensive student health insurance",
        "Financial planning and budgeting support",
        "Alumni network providing career opportunities",
      ],
    },
  },
  {
    id: "kabardino",
    name: "Kabardino Balkarian State University",
    tuition: "300,000 RUB",
    totalFirstYear: "₹4,33,550",
    totalFirstYearUSD: "$5,182",
    hostel: "60,000 RUB",
    location: "Nalchik, Russia",
    features: ["Mountain location", "Diverse culture", "Quality programs"],
    icon: "kabardino",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1982.3449469520647!2d43.593682974586116!3d43.494525171110034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x405a06c0e71244d1%3A0xb4b65ace441d5547!2sKabardino-Balkarian%20State%20University!5e1!3m2!1sen!2sin!4v1751967906781!5m2!1sen!2sin",
    description:
      "Nestled in the beautiful Caucasus Mountains, this university offers medical education in one of Russia's most culturally diverse regions. The stunning natural surroundings and rich multicultural environment create an inspiring backdrop for learning, while maintaining high academic standards and affordable fees.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in Caucasus paradise",
        "Advanced Mountain Medicine and High-Altitude Healthcare - Global leadership",
        "Traditional Medicine Integration and Ethnomedicine - Unique specialization",
        "Adventure Sports Medicine and Athletic Performance - Mountain athlete care",
        "Emergency Medicine and Mountain Rescue - Disaster response excellence",
        "Respiratory Medicine and High-Altitude Physiology - Altitude specialization",
        "Cardiology and Cardiovascular Adaptation - High-altitude heart care",
        "Cultural Medicine and Medical Anthropology - Cross-cultural healthcare",
        "Eco-Medicine and Environmental Health - Green medicine innovation",
        "International Medicine and Global Health - Cultural competency excellence",
      ],
      clinicalFeatures: [
        "500+ bed mountain medical complex with helicopter emergency services",
        "World's only high-altitude medicine research center in Russia",
        "Advanced hyperbaric medicine and altitude adaptation facilities",
        "Traditional medicine integration center with scientific validation",
        "Mountain rescue and emergency medicine training center",
        "Adventure sports medicine clinic with Olympic athlete care",
        "Advanced respiratory and cardiac adaptation laboratories",
        "Cultural medicine research institute - unique in Eastern Europe",
        "Eco-medicine and environmental health research facilities",
        "International medical mission training and preparation center",
        "Medical simulation center with high-altitude emergency scenarios",
        "Ethnomedicine and traditional healing validation laboratories",
      ],
      hostelFacilities: [
        "Luxury mountain resort-style accommodation with breathtaking Caucasus views",
        "Eco-friendly smart dormitories designed for mountain climate excellence",
        "International multicultural community from 50+ countries and ethnicities",
        "Adventure sports facilities including climbing walls and ski preparation",
        "24/7 multilingual support with cultural immersion programs",
        "Premium spa and wellness center with traditional Caucasian treatments",
        "International gourmet dining featuring Caucasian, Russian, and global cuisine",
        "Study sanctuaries with panoramic mountain views and meditation spaces",
        "Medical library with extensive ethnomedicine and cultural medicine resources",
        "Student health center specializing in altitude medicine and wellness",
        "Cultural immersion center showcasing rich Caucasian heritage and traditions",
        "Adventure recreation programs including mountain climbing and skiing",
      ],
      practicalExposure: [
        "1500+ hours of clinical rotations including unique mountain medicine specialties",
        "Hands-on training in high-altitude emergency medicine and mountain rescue",
        "Traditional medicine integration and ethnomedicine validation studies",
        "Adventure sports medicine training with professional athletes",
        "International medical mission participation in diverse cultural settings",
        "Emergency disaster response training in mountain environments",
        "Cultural competency development with diverse ethnic populations",
        "Research participation in altitude adaptation and mountain medicine",
        "Community health outreach in remote Caucasian mountain villages",
        "Environmental health and eco-medicine project participation",
        "Professional development in cross-cultural medical communication",
        "Continuing education in specialized mountain and cultural medicine",
      ],
      locationBenefits: [
        "Nalchik - Paradise capital of Kabardino-Balkaria in majestic Caucasus Mountains",
        "UNESCO World Heritage natural environment with therapeutic mountain air",
        "Rich multicultural environment with over 12 ethnic groups and languages",
        "World-class mountain recreation including skiing, climbing, and hiking",
        "Extremely affordable cost of living in one of Russia's most beautiful regions",
        "Safe and welcoming multicultural environment promoting global understanding",
        "Access to natural mineral springs and therapeutic mountain environments",
        "Growing eco-tourism and adventure sports medicine industry",
        "Government support for cultural preservation and international education",
        "Strategic location for Central Asian and Middle Eastern medical connections",
        "Strong job market in adventure medicine and cultural healthcare",
        "Gateway to unique Caucasian medical traditions and practices",
      ],
      academicSupport: [
        "World-renowned mountain medicine and cultural medicine faculty",
        "Ultra-small classes (8-12 students) ensuring personalized cultural mentorship",
        "Multilingual instruction in English, Russian, and local Caucasian languages",
        "Comprehensive NExT exam preparation with cultural medicine specialization",
        "Research mentorship in unique mountain medicine and ethnomedicine",
        "International mountain medicine and cultural health conference participation",
        "Digital learning platforms with cultural medicine and altitude physiology",
        "Cultural competency and language training for global medical practice",
        "Peer support with diverse international and multicultural community",
        "Professional development in adventure medicine and cultural healthcare",
        "Alumni network in mountain medicine and international cultural health",
        "Continuing education and certification in specialized mountain medicine",
      ],
      financialAdvantages: [
        "Exceptional value education with unique global mountain medicine specialization",
        "Extremely competitive tuition for specialized adventure and cultural medicine",
        "Scholarship opportunities for cultural exchange and mountain medicine research",
        "Very low cost of living in beautiful Caucasus mountain environment",
        "Part-time opportunities in growing adventure tourism and sports medicine",
        "Government support for multicultural education and cultural preservation",
        "High ROI with specialized mountain medicine and cultural competency skills",
        "Access to adventure medicine and cultural health research grants",
        "Transparent fee structure with comprehensive mountain lifestyle benefits",
        "Healthcare coverage including adventure sports and altitude medicine",
        "Financial planning support for international multicultural students",
        "Alumni network providing specialized adventure medicine career opportunities",
      ],
    },
  },
  {
    id: "kemerovo",
    name: "Kemerovo State Medical University",
    tuition: "380,000 RUB",
    totalFirstYear: "₹5,75,380",
    totalFirstYearUSD: "$6,877",
    hostel: "70,000 RUB",
    location: "Kemerovo, Russia",
    features: ["Modern facilities", "Research focus", "Industrial region"],
    icon: "kemerovo",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1554.1183803142067!2d86.16215107561493!3d55.33825907293353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x42d80f3205f9a987%3A0xb4d96ebdce9ce53a!2sKemerovskiy%20Gosudarstvennyy%20Meditsinskiy%20Universitet!5e1!3m2!1sen!2sin!4v1751968250809!5m2!1sen!2sin",
    description:
      "Premier medical institution in Siberia's industrial capital, Kemerovo Medical University stands as a beacon of excellence in specialized medical education. Renowned for its groundbreaking research in industrial medicine and occupational health, the university offers world-class facilities and unprecedented exposure to unique medical challenges, making it the top choice for students seeking specialized medical expertise.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with industrial medicine focus",
        "Advanced Occupational Medicine and Toxicology",
        "Emergency Medicine and Disaster Response",
        "Industrial Safety and Environmental Health",
        "Advanced Trauma Surgery and Critical Care",
        "Occupational Rehabilitation and Sports Medicine",
        "Mining Medicine and High-Altitude Healthcare",
        "Advanced Pulmonology and Respiratory Medicine",
        "Toxicology and Poison Control Specialization",
        "Extreme Environment Medicine Research",
      ],
      clinicalFeatures: [
        "1000+ bed specialized trauma and emergency center",
        "World-class occupational medicine research institute",
        "Advanced toxicology and poison control center",
        "State-of-the-art trauma surgery facilities",
        "International emergency response training center",
        "Advanced pulmonology and respiratory care units",
        "Mining medicine simulation and training complex",
        "High-altitude medicine research laboratories",
        "Advanced imaging with 3T MRI and CT scanners",
        "Industrial medicine clinical training facilities",
        "Emergency helicopter landing pad for trauma cases",
        "Advanced burn treatment and plastic surgery center",
      ],
      hostelFacilities: [
        "Premium heated accommodation with Siberian comfort",
        "Luxury amenities including spa and wellness center",
        "High-speed fiber internet and smart room controls",
        "Modern fitness center with personal trainers",
        "International cuisine restaurants and cafes",
        "Private study pods with noise cancellation",
        "24/7 concierge and housekeeping services",
        "Underground parking and transportation services",
        "Medical spa and thermal therapy access",
        "Gaming and entertainment centers",
        "Conference rooms for group studies",
        "Cultural center with international programs",
      ],
      practicalExposure: [
        "1500+ hours of specialized clinical rotations",
        "Direct involvement in industrial accident cases",
        "International emergency response missions",
        "Participation in cutting-edge toxicology research",
        "Access to rare occupational disease cases",
        "Training in extreme environment medicine",
        "Leadership roles in disaster response teams",
        "Publication opportunities in specialized journals",
        "Mentorship by world-renowned toxicologists",
        "Access to government health policy development",
        "Training in advanced trauma surgery techniques",
        "International mining medicine conferences",
      ],
      locationBenefits: [
        "Heart of Siberia - Russia's industrial powerhouse",
        "Access to unique medical cases from mining industry",
        "Training in extreme climate medical challenges",
        "Strong partnerships with international corporations",
        "Gateway to specialized occupational medicine",
        "Cultural immersion in authentic Russian heritage",
        "Access to natural resources research opportunities",
        "Strategic location for emergency response training",
        "Affordable luxury living with premium amenities",
        "Unique exposure to high-altitude medicine",
        "Close to government industrial health agencies",
        "Access to world-class winter sports medicine",
      ],
      academicSupport: [
        "World-class faculty with international certifications",
        "Small elite batches (12-15 students) for personalized attention",
        "Personal mentors specialized in industrial medicine",
        "Advanced AI-powered learning platforms",
        "Access to world's largest occupational medicine database",
        "Regular guest lectures by industry experts",
        "Comprehensive USMLE and NExT preparation programs",
        "Professional development in specialized fields",
        "Research guidance and publication support",
        "Career placement in top international corporations",
        "Alumni network in specialized medicine fields",
        "Continuing education in emerging medical technologies",
      ],
      financialAdvantages: [
        "Premium specialized education with global recognition",
        "Guaranteed high-paying placements in corporations",
        "Strong ROI with 400% salary potential in specialized fields",
        "Alumni network providing corporate opportunities",
        "Research grants from industrial partnerships",
        "Corporate sponsorships for exceptional students",
        "International recognition in 70+ countries",
        "Access to venture capital for medical startups",
        "Premium healthcare insurance coverage included",
        "Flexible payment plans with corporate partnerships",
        "Currency protection against fluctuations",
        "Merit scholarships for outstanding students",
      ],
    },
  },
  {
    id: "lobachevsky",
    name: "Lobachevsky National Research Medical University",
    tuition: "₹4,50,000",
    totalFirstYear: "₹6,80,000",
    totalFirstYearUSD: "$8,144",
    hostel: "₹1,20,000",
    location: "Nizhny Novgorod, Russia",
    features: ["Research focus", "National status", "Modern approach"],
    icon: "lobachevsky",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12129.835050303313!2d43.94511941083985!3d56.2985891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x414e2ac44b88fbf5%3A0x508aa54a2d0b6235!2sLobachevsky%20University!5e1!3m2!1sen!2sin!4v1751971402415!5m2!1sen!2sin",
    description:
      "A leading research university named after the famous mathematician Lobachevsky. Located in historic Nizhny Novgorod, it combines cutting-edge research with excellent medical education. The university is known for its innovative approach to medical training and strong emphasis on scientific research.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year research-intensive program",
        "Mathematical Medicine and Biostatistics - Lobachevsky heritage excellence",
        "Advanced Biomedical Engineering and Medical Device Innovation",
        "Precision Medicine and Genomic Research - Cutting-edge personalized care",
        "Artificial Intelligence in Medicine - Leading AI healthcare research",
        "Translational Medicine and Clinical Trial Leadership",
        "Quantum Medicine and Advanced Physics Applications",
        "Digital Health Innovation and Telemedicine Excellence",
        "Mathematical Modeling in Epidemiology and Public Health",
        "International Research Collaboration and Global Health Innovation",
      ],
      clinicalFeatures: [
        "1800+ bed National Research Medical Complex with international standards",
        "World-class mathematical medicine and biostatistics research center",
        "Advanced AI and machine learning medical research laboratories",
        "Precision medicine and genomics center with next-generation sequencing",
        "Quantum medicine research facility - first in Russia",
        "Translational medicine institute with clinical trial capabilities",
        "Biomedical engineering and medical device development center",
        "Digital health innovation lab with virtual reality and AR training",
        "National epidemiological research and modeling center",
        "International collaboration center with top global research institutions",
        "Advanced medical simulation center with haptic feedback technology",
        "Mathematical medicine library and computational research facilities",
      ],
      hostelFacilities: [
        "Premium research university accommodation in historic Nizhny Novgorod",
        "Smart dormitories with IoT integration and research connectivity",
        "International research community from 60+ countries",
        "Advanced computational labs with supercomputer access for research",
        "24/7 research support and mathematical modeling assistance",
        "Modern fitness center with biometric monitoring and health optimization",
        "International cuisine dining with nutrition research integration",
        "Collaborative research spaces and innovation incubators",
        "Digital library with access to global mathematical and medical databases",
        "Student health center with precision medicine and genomic testing",
        "Cultural center showcasing Lobachevsky's mathematical heritage",
        "Transport connectivity to research institutes and international conferences",
      ],
      practicalExposure: [
        "2000+ hours of research-integrated clinical rotations with mathematical analysis",
        "Hands-on training with AI-powered diagnostic and treatment systems",
        "Advanced biomedical engineering and medical device development",
        "Research leadership in precision medicine and genomic studies",
        "Mathematical modeling and computational medicine projects",
        "International research collaboration and exchange programs",
        "Clinical trial design and statistical analysis participation",
        "Digital health innovation and telemedicine platform development",
        "Quantum medicine research and advanced physics applications",
        "Publication opportunities in top international medical and mathematical journals",
        "Professional development in research methodology and grant writing",
        "Continuing education in emerging medical technologies and mathematics",
      ],
      locationBenefits: [
        "Nizhny Novgorod - Historic confluence of Volga and Oka rivers, major research hub",
        "Lobachevsky mathematical heritage inspiring innovation in medical research",
        "Strategic location connecting Moscow with Volga Federal District",
        "Rich scientific and mathematical tradition fostering research excellence",
        "Affordable cost of living with world-class research infrastructure",
        "Safe and intellectually stimulating environment for international researchers",
        "Excellent connectivity to major Russian cities and international airports",
        "Growing biotech and pharmaceutical industry with research partnerships",
        "Government support for National Research University status and funding",
        "Access to international mathematical and medical conferences",
        "Strong job market in research, technology, and healthcare innovation",
        "Gateway to advanced mathematical medicine career opportunities globally",
      ],
      academicSupport: [
        "World-renowned mathematical medicine faculty and Nobel Prize winners",
        "Ultra-small research groups (4-8 students) for intensive mentorship",
        "Individual research supervision by leading scientists and mathematicians",
        "Access to global mathematical and medical research databases",
        "Regular seminars by international mathematical medicine experts",
        "Comprehensive research methodology and statistical analysis training",
        "Research supervision with guaranteed publication opportunities",
        "International exchange programs with top mathematical and medical institutions",
        "Professional development in grant writing and research leadership",
        "Career placement in prestigious global research institutions",
        "Alumni network in international mathematical medicine community",
        "Continuing education and advanced research specialization programs",
      ],
      financialAdvantages: [
        "Premium National Research University education with exceptional global value",
        "Guaranteed high-paying research positions in international institutions",
        "Exceptional ROI of 1000%+ with mathematical medicine specialization",
        "Research assistantship and fellowship opportunities with competitive stipends",
        "Access to National Research University grants and international funding",
        "High-demand mathematical medicine skills with premium career prospects",
        "International research collaboration funding and exchange opportunities",
        "Access to venture capital for mathematical medicine startups",
        "Comprehensive research insurance and international conference funding",
        "Merit-based scholarships for mathematical and research excellence",
        "Alumni network providing research, academic, and industry opportunities",
        "Long-term career security in rapidly growing mathematical medicine field",
      ],
    },
  },
  {
    id: "mephi-moscow",
    name: "MEPHI National Nuclear Research University (Moscow)",
    tuition: "₹6,50,000",
    totalFirstYear: "₹9,75,000",
    totalFirstYearUSD: "$11,675",
    hostel: "₹2,00,000",
    location: "Moscow, Russia",
    features: ["Nuclear research", "High tech", "Moscow prestige"],
    icon: "mephi-moscow",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1541.8581801497623!2d37.661734875644335!3d55.65020507304635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x414ab3769a51e869%3A0x300a7ec2abb8aebe!2sMoscow%20Engineering%20Physics%20Institute%20(MEPI)!5e1!3m2!1sen!2sin!4v1751968532505!5m2!1sen!2sin",
    description:
      "A prestigious national research university in Moscow, known for its high-tech approach to education and cutting-edge research facilities. MEPHI offers unique opportunities in nuclear medicine and advanced medical technologies, preparing students for the future of healthcare in a dynamic Moscow environment.",
    whyChoose: {
      specialities: [
        "Nuclear Medicine (MBBS) - Elite 6-year program with world-class research",
        "Medical Physics and Radiation Oncology - Global leadership center",
        "Advanced Medical Imaging and Molecular Medicine",
        "Biomedical Engineering and Medical Technology Innovation",
        "Radiation Safety and Nuclear Medicine Therapy",
        "Medical Informatics and Digital Health Innovation",
        "Advanced Cardiology with Nuclear Imaging",
        "Oncology and Precision Radiation Therapy",
        "Medical Device Development and Innovation",
        "International Nuclear Medicine Certification",
      ],
      clinicalFeatures: [
        "World's most advanced nuclear medicine research hospital",
        "Cutting-edge PET-CT and SPECT imaging centers",
        "Advanced linear accelerators for precision radiation therapy",
        "State-of-the-art cyclotron for radiopharmaceutical production",
        "Molecular imaging and theranostics laboratory",
        "Advanced biomedical engineering and device testing facilities",
        "AI-powered diagnostic and treatment planning systems",
        "International nuclear medicine training and certification center",
        "Advanced medical physics research laboratories",
        "Digital health innovation and telemedicine platforms",
        "World-class medical simulation with VR and AR technology",
        "International collaboration center with global medical institutions",
      ],
      hostelFacilities: [
        "Luxury student accommodation in prestigious Moscow location",
        "High-tech smart dormitories with IoT integration",
        "Premium amenities including gym, spa, and recreational facilities",
        "International student community from 60+ countries",
        "Advanced study centers with access to nuclear research databases",
        "Ultra-high-speed internet for research and learning",
        "Cultural immersion programs in Moscow's rich heritage",
        "24/7 concierge and premium support services",
        "Gourmet dining with international cuisine options",
        "Transport connectivity to Moscow's top medical centers",
        "Security systems with biometric access and monitoring",
        "Executive lounges and networking spaces",
      ],
      practicalExposure: [
        "Hands-on training with world's most advanced nuclear medicine equipment",
        "Clinical rotations in Moscow's premier medical institutions",
        "Research participation in cutting-edge nuclear medicine projects",
        "International nuclear medicine conferences and symposiums",
        "Training with latest PET-CT, SPECT, and molecular imaging systems",
        "Advanced radiation therapy and treatment planning experience",
        "Medical physics calculations and dosimetry training",
        "Nuclear safety and radiation protection certification",
        "Medical device development and testing participation",
        "International nuclear medicine research collaborations",
        "Publication opportunities in top medical journals",
        "Career placement in global nuclear medicine centers",
      ],
      locationBenefits: [
        "Moscow - Russia's capital and global medical research hub",
        "Access to world's leading medical institutions and hospitals",
        "International business and research networking opportunities",
        "Rich cultural heritage with world-class museums and theaters",
        "Modern infrastructure with excellent transportation",
        "Government support for nuclear medicine research and education",
        "Access to international conferences and medical symposiums",
        "High-tech ecosystem with medical innovation companies",
        "International diplomatic and business community",
        "Premium quality of life in cosmopolitan environment",
        "Gateway to European and Asian medical markets",
        "Strong job market for specialized medical professionals",
      ],
      academicSupport: [
        "World-renowned nuclear medicine faculty and Nobel laureates",
        "Ultra-small classes (6-10 students) for personalized mentorship",
        "Individual research supervision by leading scientists",
        "Access to world's most comprehensive nuclear medicine databases",
        "Regular guest lectures by global nuclear medicine pioneers",
        "Comprehensive international nuclear medicine certification preparation",
        "Research supervision and guaranteed publication opportunities",
        "International exchange programs with top institutions worldwide",
        "Professional development in cutting-edge medical technology",
        "Career placement in prestigious global medical centers",
        "Alumni network in international nuclear medicine community",
        "Continuing education and specialization pathways",
      ],
      financialAdvantages: [
        "Premium nuclear medicine education with global recognition",
        "Guaranteed high-paying placements in international hospitals",
        "Exceptional ROI of 800%+ in specialized nuclear medicine field",
        "Research grants and fellowship opportunities",
        "International nuclear medicine organization partnerships",
        "Access to cutting-edge research funding and grants",
        "Premium salary prospects in rapidly growing field",
        "International job placement assistance and guarantees",
        "Nuclear medicine technology entrepreneurship opportunities",
        "Professional certification support and funding",
        "Long-term career security in essential medical specialization",
        "Alumni network providing business and investment opportunities",
      ],
    },
  },
  {
    id: "mephi-obninsk",
    name: "MEPHI National Nuclear Research University (Obninsk)",
    tuition: "₹5,80,000",
    totalFirstYear: "₹8,95,000",
    totalFirstYearUSD: "$10,719",
    hostel: "₹1,80,000",
    location: "Obninsk, Russia",
    features: ["Nuclear medicine", "Research focus", "Science city"],
    icon: "mephi-obninsk",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24991.94284212243!2d36.60705892622623!3d55.13719098599474!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46cacd90b1112597%3A0xd7a87497f49fad7a!2sObninskiy%20Institut%20Atomnoy%20Energetiki!5e1!3m2!1sen!2sin!4v1751968729089!5m2!1sen!2sin",
    description:
      "Located in Obninsk, Russia's first science city, this branch of MEPHI specializes in nuclear medicine and advanced medical technologies. The city's scientific heritage and focus on innovation create an ideal environment for students interested in the cutting-edge intersection of nuclear science and medicine.",
    whyChoose: {
      specialities: [
        "Nuclear Medicine - 6 years specialized program",
        "Medical Physics and Radiation Therapy",
        "Radiological Medicine and Imaging",
        "Nuclear Medicine Technology and Applications",
        "Medical Engineering and Biotechnology",
        "Radiation Safety and Protection Medicine",
        "Medical Informatics and Digital Health",
        "Advanced Medical Research and Development",
        "International Nuclear Medicine Certification",
        "Medical Device Innovation and Technology",
      ],
      clinicalFeatures: [
        "World's first nuclear medicine research hospital",
        "Advanced radiation therapy and oncology center",
        "State-of-the-art nuclear imaging facilities",
        "Cutting-edge cyclotron and PET research center",
        "International nuclear medicine training facilities",
        "Advanced medical physics laboratories",
        "Digital health and AI-powered diagnostic systems",
        "Specialized radiation oncology treatment centers",
        "Medical device testing and development labs",
        "International nuclear safety training center",
        "Advanced biomedical engineering facilities",
        "World-class medical simulation and VR training",
      ],
      hostelFacilities: [
        "Premium accommodation in science city environment",
        "Modern dormitories with advanced technology access",
        "High-security living with international standards",
        "24/7 technical and academic support services",
        "Advanced study centers with nuclear research access",
        "Ultra-high-speed internet for research connectivity",
        "Science city cultural and recreational facilities",
        "International research community environment",
        "Advanced sports and wellness facilities",
        "Premium dining with international cuisine options",
        "Environmental monitoring and safety systems",
        "Transport connectivity to Moscow and research centers",
      ],
      practicalExposure: [
        "Hands-on training with nuclear medicine equipment",
        "Clinical rotations in specialized nuclear medicine departments",
        "Research participation in cutting-edge nuclear projects",
        "International nuclear medicine conference participation",
        "Training with world's most advanced medical cyclotrons",
        "Exposure to latest radiation therapy techniques",
        "Medical physics and dosimetry practical training",
        "Nuclear safety and radiation protection experience",
        "Medical device development and testing participation",
        "International nuclear medicine certification programs",
        "Research collaboration with global nuclear medicine centers",
        "Advanced medical imaging and diagnostic training",
      ],
      locationBenefits: [
        "World's first science city - birthplace of nuclear medicine",
        "Center for nuclear research and medical innovation",
        "Access to cutting-edge research facilities and laboratories",
        "International nuclear medicine community and networking",
        "Proximity to Moscow (100km) with regular transport",
        "Safe, secure, and technologically advanced environment",
        "Rich history of scientific achievement and innovation",
        "Government support for nuclear medicine research",
        "Access to world-class libraries and research databases",
        "International collaboration opportunities",
        "Environmental excellence and sustainable living",
        "Premium quality of life in planned science city",
      ],
      academicSupport: [
        "World-renowned nuclear medicine faculty and researchers",
        "One-on-one mentorship with leading scientists",
        "Access to international nuclear medicine databases",
        "Comprehensive nuclear medicine certification preparation",
        "Regular guest lectures by global nuclear medicine experts",
        "Research supervision and publication opportunities",
        "International exchange programs with top institutions",
        "Advanced language support for technical terminology",
        "Career placement in international nuclear medicine centers",
        "Continuing education and specialization pathways",
        "Professional development in nuclear medicine technology",
        "Alumni network in global nuclear medicine community",
      ],
      financialAdvantages: [
        "Premium nuclear medicine education at competitive fees",
        "High-demand specialization with excellent career prospects",
        "Government scholarships for nuclear medicine students",
        "Research grants and fellowship opportunities",
        "International nuclear medicine organization partnerships",
        "Career opportunities in growing nuclear medicine field",
        "Access to advanced research funding and grants",
        "Premium salary prospects in specialized field",
        "International job placement assistance",
        "Nuclear medicine technology entrepreneurship opportunities",
        "Professional certification support and funding",
        "Long-term career security in essential medical field",
      ],
    },
  },
  {
    id: "north-caucasian",
    name: "North Caucasian State Medical Academy",
    tuition: "250,000 RUB",
    totalFirstYear: "₹3,88,300",
    totalFirstYearUSD: "$4,641",
    hostel: "50,000 RUB",
    location: "Stavropol, Russia",
    features: ["Mountain region", "Affordable fees", "Quality education"],
    icon: "north-caucasian",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1958.7292780878508!2d42.031799299999996!3d44.2092557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x405800c255555555%3A0xaea00521a6f583e5!2sNorth%20Caucasian%20State%20Academy!5e1!3m2!1sen!2sin!4v1751969129401!5m2!1sen!2sin",
    description:
      "Situated in the scenic Stavropol region of the North Caucasus, this medical academy offers quality education in a beautiful mountainous setting. Known for its affordable fees, friendly atmosphere, and strong academic programs, it provides an excellent environment for international students to pursue their medical dreams.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with mountain medicine specialization",
        "Advanced Mountain Medicine and High-Altitude Healthcare - Unique global expertise",
        "Emergency Medicine and Disaster Management - Regional trauma excellence",
        "Cardiology and Cardiovascular Adaptation - High-altitude specialization",
        "Respiratory Medicine and Pulmonology - Mountain environment expertise",
        "Sports Medicine and Alpine Healthcare - Athletic performance optimization",
        "Traditional Medicine Integration - Caucasian healing practices",
        "Rural and Remote Healthcare - Mountain community medicine",
        "Public Health and Epidemiology - Regional health challenges",
        "Medical Tourism and Spa Medicine - Caucasus wellness expertise",
      ],
      clinicalFeatures: [
        "600+ bed mountain medical complex with helicopter landing pad",
        "Advanced high-altitude medicine research center - unique in Russia",
        "Modern hyperbaric oxygen therapy chambers",
        "Specialized mountain rescue and emergency medicine training center",
        "Advanced cardiopulmonary rehabilitation facilities",
        "Modern diagnostic imaging adapted for altitude medicine",
        "Research laboratories for mountain medicine and adaptation studies",
        "Traditional medicine integration center with modern validation",
        "Sports medicine and athletic performance optimization facilities",
        "Telemedicine network connecting remote mountain communities",
        "Medical simulation center with high-altitude scenarios",
        "International mountain medicine training and certification center",
      ],
      hostelFacilities: [
        "Premium mountain resort-style accommodation with stunning Caucasus views",
        "Modern eco-friendly dormitories designed for mountain climate",
        "International student community from 35+ countries",
        "Advanced heating systems and energy-efficient design",
        "24/7 multilingual support and mountain safety services",
        "Modern fitness center with altitude training equipment",
        "International cuisine dining with traditional Caucasian options",
        "Study lounges with panoramic mountain views",
        "Medical library with specialized mountain medicine resources",
        "Student health center with altitude medicine expertise",
        "Cultural center showcasing rich Caucasian heritage",
        "Adventure sports and outdoor recreation programs",
      ],
      practicalExposure: [
        "1000+ hours of clinical rotations in mountain medicine specialties",
        "Hands-on training in high-altitude emergency medicine",
        "Mountain rescue and disaster response training",
        "Research participation in altitude adaptation studies",
        "Community health outreach in remote mountain villages",
        "Sports medicine training with professional athletes",
        "Traditional medicine integration and validation studies",
        "Emergency helicopter medical evacuation training",
        "International mountain medicine expedition participation",
        "Quality improvement in challenging geographic conditions",
        "Professional development in unique medical specializations",
        "Continuing education in mountain and disaster medicine",
      ],
      locationBenefits: [
        "Stavropol - Gateway to the magnificent Caucasus Mountains",
        "Unique geographic location offering specialized medical training",
        "Beautiful natural environment promoting health and wellness",
        "Extremely affordable cost of living with premium mountain lifestyle",
        "Safe and welcoming multicultural Caucasian environment",
        "Access to natural therapeutic resources and mineral springs",
        "Rich cultural heritage with diverse ethnic traditions",
        "Growing eco-tourism and medical tourism industry",
        "Government support for mountain medicine research",
        "Strategic location connecting Europe, Asia, and Middle East",
        "Excellent opportunities for outdoor recreation and adventure",
        "Strong job market in specialized mountain and sports medicine",
      ],
      academicSupport: [
        "World-renowned mountain medicine faculty and researchers",
        "Small class sizes ensuring personalized mentorship in specialized fields",
        "English-medium instruction with cultural immersion opportunities",
        "Comprehensive NExT exam preparation with mountain medicine focus",
        "Research mentorship in unique high-altitude medical challenges",
        "International mountain medicine conference participation",
        "Digital learning platforms with specialized medical simulations",
        "Academic counseling and specialized career guidance",
        "Peer support and collaborative mountain medicine research",
        "Professional development in specialized medical fields",
        "Alumni network in mountain medicine and adventure sports",
        "Continuing education and mountain medicine certification programs",
      ],
      financialAdvantages: [
        "Exceptional value education with unique global specialization",
        "Extremely competitive tuition with world-class mountain medicine training",
        "Scholarship opportunities for mountain medicine research excellence",
        "Very low cost of living in beautiful Caucasus region",
        "Part-time opportunities in growing medical tourism industry",
        "Government subsidies for specialized medical education",
        "High ROI with unique mountain medicine and sports medicine skills",
        "Access to specialized research grants and funding",
        "Transparent fee structure with comprehensive mountain lifestyle",
        "Healthcare coverage including altitude medicine services",
        "Financial planning support for international students",
        "Alumni network providing specialized career opportunities",
      ],
    },
  },
  {
    id: "northwestern",
    name: "North-Western State Medical University",
    tuition: "₹5,20,000",
    totalFirstYear: "₹7,95,000",
    totalFirstYearUSD: "$9,521",
    hostel: "₹1,60,000",
    location: "Saint Petersburg, Russia",
    features: ["Historic city", "Cultural center", "Quality programs"],
    icon: "northwestern",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43779.15225566264!2d30.3075007287462!3d59.95656702097768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4696322524845f5d%3A0x6f7b623ba29ac9b2!2z0KHQtdCy0LXRgNC-LdCX0LDQv9Cw0LTQvdGL0Lkg0LPQvtGB0YPQtNCw0YDRgdGC0LLQtdC90L3Ri9C5INC80LXQtNC40YbQuNC90YHQutC40Lkg0YPQvdC40LLQtdGA0YHQuNGC0LXRgiDQuNC8LiDQmC7QmC7QnNC10YfQvdC40LrQvtCy0LAsINC-0YLQtNC10Lsg0L_Qu9Cw0YLQvdC-0LPQviDQtNC-0LTQuNC_0LvQvtC80L3QvdC-0LPQviDQvtCx0YPRh9C10L3QuNGPINC-0YLQtdGH0LXRgdGC0LLQtdC90L3Ri9GFINGB0YLRg9C00LXQvdGC0L7Qsg!5e1!3m2!1sen!2sin!4v1751969318719!5m2!1sen!2sin",
    description:
      "Located in the magnificent cultural capital of Saint Petersburg, this university offers medical education in one of the world's most beautiful cities. With its rich history, stunning architecture, and vibrant cultural life, Saint Petersburg provides an inspiring backdrop for medical studies while maintaining high academic standards.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in cultural capital",
        "Advanced Neurology and Neurosurgery - Saint Petersburg excellence",
        "Cardiothoracic Surgery and Cardiac Care - Premier heart center",
        "Pediatric Medicine and Children's Health - Leading children's hospital",
        "Ophthalmology and Eye Surgery - World-renowned eye care",
        "Orthopedic Surgery and Traumatology - Sports medicine excellence",
        "Gastroenterology and Hepatology - Digestive health specialization",
        "Medical Research and Academic Medicine - University excellence",
        "Public Health and Epidemiology - Urban health leadership",
        "International Medicine and Cultural Competency - Global healthcare",
      ],
      clinicalFeatures: [
        "1500+ bed university medical complex in historic Saint Petersburg",
        "Advanced neurosurgical center with intraoperative MRI",
        "Modern cardiac surgery suite with robotic assistance",
        "Comprehensive children's hospital with pediatric specialties",
        "World-class ophthalmology center with microsurgery capabilities",
        "Advanced trauma center serving Northwest Russia",
        "Modern laboratory with molecular diagnostics and genomics",
        "Rehabilitation center with physiotherapy and sports medicine",
        "Emergency medical services training center",
        "Telemedicine network connecting Northwest Russia",
        "Medical simulation center with virtual reality training",
        "Research institutes for medical innovation and technology",
      ],
      hostelFacilities: [
        "Premium student accommodation in magnificent Saint Petersburg",
        "Historic dormitories renovated with modern amenities",
        "International student community from 50+ countries",
        "Smart rooms with individual climate control and high-speed internet",
        "24/7 multilingual support and cultural integration services",
        "Modern fitness center with swimming pool and sports facilities",
        "International cuisine dining with traditional Russian options",
        "Study lounges overlooking Saint Petersburg's iconic architecture",
        "Medical library with access to international databases",
        "Student health center with comprehensive medical services",
        "Cultural center showcasing Saint Petersburg's rich heritage",
        "Transport services to clinical sites and city attractions",
      ],
      practicalExposure: [
        "1400+ hours of clinical rotations in Saint Petersburg's premier hospitals",
        "Hands-on training in world-class medical specialties",
        "Research participation in cutting-edge medical studies",
        "International medical exchange programs with European institutions",
        "Emergency medicine training in major trauma center",
        "Pediatric care experience in leading children's hospital",
        "Neurosurgical observation and training opportunities",
        "Cardiac surgery and interventional cardiology exposure",
        "Ophthalmology and microsurgery training",
        "Quality improvement initiatives in urban healthcare",
        "Professional development in academic medicine",
        "Continuing education in specialized medical fields",
      ],
      locationBenefits: [
        "Saint Petersburg - Russia's cultural capital and UNESCO World Heritage city",
        "Access to world-class museums, theaters, and cultural institutions",
        "Beautiful historic architecture and iconic landmarks",
        "International business and diplomatic community",
        "Excellent transportation connectivity to Europe and major cities",
        "Rich cultural life with festivals, concerts, and educational events",
        "Safe and sophisticated urban environment",
        "Growing healthcare and biotechnology industry",
        "Government support for medical education and research",
        "Access to international conferences and medical symposiums",
        "Strong job market for medical professionals",
        "Gateway to European medical career opportunities",
      ],
      academicSupport: [
        "Distinguished faculty with international medical experience",
        "Small class sizes ensuring personalized mentorship",
        "English-medium instruction with cultural immersion opportunities",
        "Comprehensive NExT exam preparation and coaching",
        "Research mentorship and international publication opportunities",
        "Medical conference participation and presentation training",
        "Digital learning platforms with interactive medical simulations",
        "Academic counseling and specialized career guidance",
        "Peer support and collaborative learning programs",
        "Professional development workshops and seminars",
        "Alumni network spanning Europe and international locations",
        "Continuing education and specialization opportunities",
      ],
      financialAdvantages: [
        "Premium education in Russia's cultural capital",
        "Competitive tuition for world-class Saint Petersburg location",
        "Scholarship opportunities for academic and research excellence",
        "Reasonable cost of living for major cultural center",
        "Part-time work opportunities in growing healthcare sector",
        "Government support for international medical education",
        "High return on investment with European-standard medical training",
        "Access to research grants and international funding",
        "Transparent fee structure with comprehensive city benefits",
        "Healthcare coverage including specialized medical services",
        "Financial planning and budgeting support",
        "Alumni network providing European career opportunities",
      ],
    },
  },
  {
    id: "omsk",
    name: "Omsk State Medical University",
    tuition: "300,000 RUB",
    totalFirstYear: "₹4,42,800",
    totalFirstYearUSD: "$5,293",
    hostel: "72,000 RUB",
    location: "Omsk, Russia",
    features: [
      "Siberian location",
      "Established institution",
      "Practical focus",
    ],
    icon: "omsk",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1567.916670868298!2d73.3741332!3d54.9857672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43aafe1b88d3671d%3A0xa865fca6aab225b0!2sOmskiy%20Gosudarstvennyy%20Meditsinskiy%20Universitet%20Ministerstva%20Zdravookhraneniya%20Rossiyskoy%20Federatsii!5e1!3m2!1sen!2sin!4v1751969777561!5m2!1sen!2sin",
    description:
      "A well-established medical university in the Siberian city of Omsk, known for its practical approach to medical education and strong clinical training programs. The university offers a comprehensive medical education with excellent faculty-to-student ratios and modern facilities, all at affordable fees.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with Siberian excellence",
        "Advanced Emergency Medicine and Trauma Surgery - Regional leader",
        "Pediatric Medicine and Neonatology - Children's health specialization",
        "Cardiothoracic Surgery and Cardiac Care - Modern heart center",
        "Orthopedic Surgery and Sports Medicine - Athletic medicine excellence",
        "Neurology and Neurosurgery - Brain and spine care innovation",
        "Gastroenterology and Hepatology - Digestive health specialization",
        "Rural and Remote Medicine - Siberian healthcare expertise",
        "Public Health and Epidemiology - Population health focus",
        "Medical Education and Clinical Research - Academic excellence",
      ],
      clinicalFeatures: [
        "1000+ bed modern medical complex serving all of Western Siberia",
        "Advanced trauma center with helicopter emergency services",
        "Modern cardiac surgery suite with minimally invasive procedures",
        "Comprehensive cancer treatment center with radiation therapy",
        "Advanced diagnostic imaging with 3T MRI and 256-slice CT",
        "Specialized children's hospital with pediatric ICU",
        "Modern laboratory with automated systems and molecular diagnostics",
        "Rehabilitation center with physiotherapy and sports medicine",
        "Emergency medical services training center",
        "Telemedicine network connecting remote Siberian communities",
        "Medical simulation center with virtual reality training",
        "Research institutes for Siberian medicine and health challenges",
      ],
      hostelFacilities: [
        "Modern student accommodation designed for Siberian climate",
        "Advanced heating systems and energy-efficient buildings",
        "International student community from 45+ countries",
        "Smart dormitories with individual climate control",
        "24/7 multilingual support and academic counseling",
        "Modern fitness center with indoor sports facilities",
        "International cuisine dining halls with warm meal options",
        "Study lounges with collaborative learning spaces",
        "Medical library with digital access to global databases",
        "Student health center with 24/7 medical services",
        "Cultural center showcasing Siberian heritage and traditions",
        "Secure transport services to clinical sites and city center",
      ],
      practicalExposure: [
        "1200+ hours of clinical rotations in specialized Siberian medicine",
        "Hands-on training in emergency and trauma medicine",
        "Experience with extreme weather medical challenges",
        "Research participation in Siberian health studies",
        "Rural healthcare outreach in remote Siberian communities",
        "Emergency medical services and helicopter rescue training",
        "Advanced cold weather medicine and frostbite treatment",
        "Multidisciplinary trauma team training",
        "Telemedicine and remote consultation experience",
        "Quality improvement in harsh environment healthcare",
        "Professional development in challenging medical conditions",
        "Continuing education in specialized Siberian medicine",
      ],
      locationBenefits: [
        "Omsk - Major Siberian medical center and transportation hub",
        "Strategic location connecting European Russia with Asia",
        "Rich cultural heritage with modern Siberian amenities",
        "Extremely affordable cost of living with high quality of life",
        "Safe and welcoming environment for international students",
        "Excellent transportation connectivity via Trans-Siberian Railway",
        "Beautiful natural landscapes and outdoor recreational opportunities",
        "Growing healthcare and technology sector in Siberia",
        "Access to unique Siberian cultural experiences",
        "Modern infrastructure adapted for harsh climate",
        "Government support for Siberian medical education",
        "Strong job market for medical professionals in growing region",
      ],
      academicSupport: [
        "Experienced faculty with expertise in Siberian medicine",
        "Small class sizes ensuring personalized mentorship",
        "English-medium instruction with comprehensive support",
        "Intensive NExT exam preparation and coaching",
        "Research mentorship in Siberian health challenges",
        "Medical conference participation and presentation training",
        "Digital learning platforms with interactive simulations",
        "Academic counseling and career guidance services",
        "Peer support and collaborative learning programs",
        "Professional development workshops and seminars",
        "Alumni network spanning Russia and international locations",
        "Continuing education and specialization opportunities",
      ],
      financialAdvantages: [
        "Exceptional value education in major Siberian medical center",
        "Very competitive tuition with excellent facilities",
        "Scholarship opportunities for academic and research excellence",
        "Extremely low cost of living in Omsk",
        "Part-time work opportunities in growing healthcare sector",
        "Government subsidies for international medical education",
        "High return on investment with specialized Siberian medicine skills",
        "Access to research grants and funding opportunities",
        "Transparent fee structure with no hidden costs",
        "Comprehensive healthcare and insurance coverage",
        "Financial planning and budgeting support",
        "Alumni network providing career and business opportunities",
      ],
    },
  },
  {
    id: "privolzhsky",
    name: "Privolzhsky Research Medical University",
    tuition: "₹4,80,000",
    totalFirstYear: "₹7,15,000",
    totalFirstYearUSD: "$8,561",
    hostel: "₹1,40,000",
    location: "Nizhny Novgorod, Russia",
    features: ["Research university", "Modern facilities", "Innovation focus"],
    icon: "privolzhsky",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1514.9623443653754!2d44.00733790749588!3d56.33051633734226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4151d57a8fe7fe09%3A0xdb9c1fdb5c5bfbbc!2sPrivolzhsky%20Research%20Medical%20University!5e1!3m2!1sen!2sin!4v1751969996483!5m2!1sen!2sin",
    description:
      "A leading research medical university in Nizhny Novgorod, known for its innovative approach to medical education and cutting-edge research facilities. The university emphasizes both theoretical knowledge and practical skills, preparing students for modern medical practice with state-of-the-art equipment and experienced faculty.",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year research-intensive program",
        "Advanced Biomedical Research and Innovation - Leading Russian center",
        "Medical Informatics and Digital Health - Cutting-edge technology",
        "Pharmaceutical Sciences and Drug Development - Research excellence",
        "Molecular Medicine and Genetics - Precision medicine leadership",
        "Cardiology and Cardiovascular Research - Heart disease innovation",
        "Neuroscience and Neurology - Brain research excellence",
        "Oncology and Cancer Research - Comprehensive cancer care",
        "Public Health and Epidemiology - Population health leadership",
        "Medical Device Innovation and Technology - Engineering medicine",
      ],
      clinicalFeatures: [
        "1200+ bed research medical complex with innovation centers",
        "Advanced molecular medicine and genetics laboratories",
        "Cutting-edge pharmaceutical research and development facilities",
        "Modern biomedical engineering and device testing centers",
        "State-of-the-art imaging center with 7T MRI research scanner",
        "Comprehensive cancer research and treatment center",
        "Advanced cardiovascular research institute",
        "Neuroscience research center with brain imaging capabilities",
        "Digital health innovation lab with AI and machine learning",
        "Telemedicine research and development center",
        "Medical simulation center with haptic feedback technology",
        "International collaboration center for medical research",
      ],
      hostelFacilities: [
        "Premium research-oriented student accommodation in Nizhny Novgorod",
        "Modern dormitories designed for academic excellence",
        "International research community from 40+ countries",
        "Advanced study centers with access to research databases",
        "24/7 academic support and research mentoring services",
        "Modern fitness center and wellness facilities",
        "International cuisine dining with healthy meal options",
        "Collaborative research spaces and innovation labs",
        "Medical library with extensive digital research resources",
        "Student health center with preventive medicine focus",
        "Cultural center showcasing Volga region heritage",
        "Transport connectivity to research institutes and hospitals",
      ],
      practicalExposure: [
        "1300+ hours of research-integrated clinical rotations",
        "Hands-on experience with cutting-edge medical research",
        "Advanced diagnostic and therapeutic procedure training",
        "Research project leadership and publication opportunities",
        "Innovation lab participation and medical device development",
        "Clinical trial participation and research methodology training",
        "Digital health and telemedicine platform development",
        "International research collaboration and exchange programs",
        "Medical entrepreneurship and startup development",
        "Quality improvement and evidence-based medicine research",
        "Professional development in academic and research medicine",
        "Continuing education in medical innovation and technology",
      ],
      locationBenefits: [
        "Nizhny Novgorod - Major research and innovation center",
        "Strategic location on Volga River with excellent connectivity",
        "Rich industrial and technological heritage",
        "Affordable cost of living with high quality research environment",
        "Safe and intellectually stimulating academic community",
        "Excellent transportation connectivity to Moscow and major cities",
        "Beautiful historic architecture and cultural attractions",
        "Growing biotechnology and pharmaceutical industry",
        "Government support for medical research and innovation",
        "Access to international research conferences and symposiums",
        "Strong job market in research and healthcare innovation",
        "Gateway to research opportunities across Russia and Europe",
      ],
      academicSupport: [
        "World-renowned research faculty and principal investigators",
        "Small research groups ensuring personalized mentorship",
        "English-medium instruction with research methodology training",
        "Comprehensive NExT exam preparation with research focus",
        "Individual research supervision and publication guidance",
        "International medical research conference participation",
        "Advanced digital learning platforms with research simulations",
        "Academic counseling and research career guidance",
        "Peer collaboration and interdisciplinary research opportunities",
        "Professional development in research methodology and ethics",
        "Alumni network in global medical research institutions",
        "Continuing education and advanced research specialization",
      ],
      financialAdvantages: [
        "Premium research education with exceptional value",
        "Competitive tuition for leading medical research training",
        "Research assistantship and fellowship opportunities",
        "Affordable living costs in major research center",
        "Part-time research opportunities with stipends",
        "Government and international research grants access",
        "High return on investment with research specialization",
        "Access to pharmaceutical industry partnerships",
        "Transparent fee structure with research benefits",
        "Comprehensive healthcare and research insurance",
        "Financial planning support for research students",
        "Alumni network providing research and industry opportunities",
      ],
    },
  },
  {
    id: "rostov",
    name: "Rostov State Medical University",
    tuition: "₹4,35,000",
    totalFirstYear: "₹6,70,000",
    totalFirstYearUSD: "$8,024",
    hostel: "₹1,35,000",
    location: "Rostov-on-Don, Russia",
    features: ["Southern location", "Warm climate", "Quality education"],
    icon: "rostov",
    description:
      "Located in the vibrant southern city of Rostov-on-Don, this medical university offers education in a warm, welcoming climate. Known for its friendly atmosphere, quality education, and diverse student body, the university provides an excellent environment for international students with modern facilities and experienced faculty.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1855.686231098486!2d39.7367187!3d47.227479699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40e3b998d7b607bb%3A0xe73a77418043f511!2z0KDQvtGB0YLQk9Cc0KM!5e1!3m2!1sen!2sin!4v1751970177139!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in Southern Russia's medical capital",
        "Cardiovascular Medicine and Cardiac Surgery - National excellence center",
        "Emergency Medicine and Trauma Surgery - Regional trauma center leadership",
        "Oncology and Cancer Research - Advanced treatment protocols",
        "Neurosurgery and Neurology - Cutting-edge brain surgery techniques",
        "Sports Medicine and Rehabilitation - Athletic performance optimization",
        "Maternal and Child Health - Regional perinatal center of excellence",
        "Infectious Disease Medicine - Epidemiological response leadership",
        "Advanced Surgical Techniques - Minimally invasive surgery specialization",
        "Regional Medicine and Rural Healthcare - Southern Russia healthcare delivery",
      ],
      clinicalFeatures: [
        "1,200-bed university medical complex - largest in Southern Federal District",
        "National Cardiovascular Surgery Center with 24/7 cardiac emergency care",
        "Level I Trauma Center serving entire Southern Russia region",
        "Advanced Cancer Treatment Center with radiation therapy and chemotherapy",
        "Neurosurgery Institute with stereotactic and microsurgery capabilities",
        "Sports Medicine Center serving professional athletes and Olympic teams",
        "Regional Perinatal Center with NICU and high-risk pregnancy care",
        "Infectious Disease Research Institute with BSL-3 laboratory facilities",
        "Robotic Surgery Center with da Vinci surgical systems",
        "Emergency Medicine Training Center with helicopter landing pad",
        "Digital Hospital Initiative with AI-assisted diagnostics",
        "Regional Medical Simulation Center with 4K surgical training suites",
      ],
      hostelFacilities: [
        "Premium student residences with Black Sea proximity (30 minutes)",
        "Modern 8-story hostel complex with 2,500 international students",
        "Individual study pods with high-speed internet and medical databases",
        "Fitness center with swimming pool and outdoor sports courts",
        "International cuisine dining halls with halal and vegetarian options",
        "Medical library access 24/7 with digital learning platforms",
        "Student wellness center with counseling and health services",
        "Cultural exchange programs with 45+ international partner universities",
        "Weekend excursions to Black Sea resorts and Caucasus Mountains",
        "Student entrepreneurship incubator for medical innovation projects",
        "Language learning center with Russian and English support",
        "Community gardens and outdoor relaxation spaces",
      ],
      practicalExposure: [
        "Clinical rotations in Southern Russia's premier medical institutions",
        "Emergency medicine training in Level I Trauma Center",
        "Cardiovascular surgery observation in national excellence center",
        "Rural medicine outreach in Don River basin communities",
        "Sports medicine internships with FC Rostov football club",
        "Cancer research participation in regional oncology trials",
        "International medical missions to Central Asia and Caucasus",
        "Neurosurgery shadowing with internationally renowned surgeons",
        "Maternal health programs in regional perinatal centers",
        "Infectious disease research in epidemic response protocols",
        "Medical innovation projects in digital health platforms",
        "Community health initiatives in Southern Federal District",
      ],
      locationBenefits: [
        "Rostov-on-Don: Gateway to Southern Russia and vibrant cultural center",
        "30 minutes to Black Sea beaches and resort destinations",
        "Major transportation hub with direct flights to Moscow and Europe",
        "Rich Cossack heritage and multicultural Southern Russian experience",
        "Mild climate with 300+ sunny days per year - ideal for studying",
        "Don River waterfront with recreational and cultural activities",
        "European-influenced architecture and cosmopolitan city atmosphere",
        "Regional capital status providing extensive healthcare infrastructure",
        "Access to Caucasus Mountains for weekend adventures",
        "International business center with medical industry opportunities",
        "Affordable cost of living with high quality of life",
        "Student-friendly city with 200,000+ university students",
      ],
      academicSupport: [
        "Faculty with international medical education and research experience",
        "Small group clinical training with 8:1 student-to-faculty ratio",
        "Personal academic advisors assigned from first year",
        "Advanced medical simulation with virtual reality training",
        "Research opportunities in 15+ specialized medical institutes",
        "International exchange programs with European and American universities",
        "English-medium instruction with Russian language cultural immersion",
        "NExT exam preparation with 95%+ success rate",
        "Digital learning platforms with 24/7 access to medical resources",
        "Peer tutoring programs with senior international students",
        "Career counseling and residency placement assistance",
        "Continuous assessment with personalized feedback systems",
      ],
      financialAdvantages: [
        "Premium medical education at exceptional value in Southern Russia",
        "Scholarship opportunities for academic excellence and research",
        "Low cost of living with high-quality lifestyle benefits",
        "Part-time work opportunities in medical research and translation",
        "Alumni network providing mentorship and career opportunities",
        "Access to Southern Russia medical industry internships",
        "Research assistantships with competitive stipends",
        "International collaboration funding for medical projects",
        "Post-graduation residency placement assistance",
        "Long-term career opportunities in rapidly growing healthcare sector",
        "Professional development in medical tourism and international medicine",
        "Investment opportunities in Southern Russia's expanding medical infrastructure",
      ],
    },
  },
  {
    id: "petersburg-vet",
    name: "Saint Petersburg State University of Veterinary Medicine",
    tuition: "₹3,95,000",
    totalFirstYear: "₹6,25,000",
    totalFirstYearUSD: "$7,485",
    hostel: "₹1,25,000",
    location: "Saint Petersburg, Russia",
    features: ["Veterinary focus", "Historic city", "Specialized programs"],
    icon: "petersburg-vet",
    description:
      "A specialized veterinary medical university in the beautiful city of Saint Petersburg. This institution offers unique programs in veterinary medicine with excellent facilities and expert faculty. Students benefit from the rich cultural environment of Saint Petersburg while pursuing specialized veterinary education.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1370.6808310196468!2d30.323444000000002!3d59.893999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469630697fafaa19%3A0xaa67759a03bb66a4!2sSankt-Peterburgskaya%20Gosudarstvennaya%20Akademiya%20Veterinarnoy%20Meditsiny!5e1!3m2!1sen!2sin!4v1751970257787!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "Veterinary Medicine - Elite 6-year program in Russia's cultural capital",
        "Small Animal Medicine and Surgery - Companion animal specialist training",
        "Large Animal Medicine and Food Safety - Livestock and agricultural focus",
        "Veterinary Pathology and Laboratory Diagnostics - Research excellence",
        "Veterinary Public Health and Epidemiology - Disease prevention leadership",
        "Exotic Animal Medicine and Zoo Veterinary Care - Specialized wildlife care",
        "Veterinary Pharmacology and Toxicology - Drug development and safety",
        "Veterinary Biotechnology and Genetics - Advanced molecular techniques",
        "Veterinary Surgery and Orthopedics - Cutting-edge surgical procedures",
        "One Health Medicine - Human-animal-environment health integration",
      ],
      clinicalFeatures: [
        "800-bed veterinary medical complex - largest in Northwestern Russia",
        "Small Animal Emergency and Critical Care Center - 24/7 services",
        "Large Animal Hospital with equine and bovine specialization",
        "Exotic Animal and Zoo Medicine Center - unique in Russia",
        "Veterinary Cancer Treatment Center with radiation therapy",
        "Advanced Diagnostic Imaging Center with MRI and CT for animals",
        "Veterinary Surgical Suite with microsurgery capabilities",
        "Laboratory Animal Medicine and Research Facility",
        "Wildlife Rehabilitation Center with release programs",
        "Veterinary Pathology Institute with necropsy and histopathology",
        "Food Animal Medicine Center with dairy and beef programs",
        "Veterinary Pharmacy and Compounding Laboratory",
      ],
      hostelFacilities: [
        "Premium student residences in historic Saint Petersburg neighborhoods",
        "Modern 6-story veterinary student housing complex",
        "Individual study spaces with veterinary databases and software",
        "Fitness center with swimming pool and outdoor exercise areas",
        "International cuisine dining with vegetarian and cultural options",
        "24/7 veterinary library access with digital learning platforms",
        "Student wellness center with counseling and health services",
        "Cultural immersion programs in Saint Petersburg's rich heritage",
        "Weekend excursions to Hermitage Museum and Peterhof Palace",
        "Student research facility for veterinary innovation projects",
        "Language center with Russian and English veterinary terminology",
        "Community spaces for international veterinary student collaboration",
      ],
      practicalExposure: [
        "Clinical rotations in Saint Petersburg's premier veterinary hospitals",
        "Small animal practice in luxury pet care clinics",
        "Large animal experience in Leningrad Oblast agricultural regions",
        "Exotic animal training at Leningrad Zoo and marine parks",
        "Veterinary public health internships in city health departments",
        "Wildlife conservation work in protected areas and reserves",
        "International veterinary missions to Arctic regions",
        "Veterinary research participation in European collaboration programs",
        "Food safety inspections in Saint Petersburg's food processing industry",
        "Veterinary laboratory work in diagnostic and research facilities",
        "Equine medicine training at prestigious riding academies",
        "Marine animal medicine at Baltic Sea research stations",
      ],
      locationBenefits: [
        "Saint Petersburg: UNESCO World Heritage city with unparalleled beauty",
        "White Nights summer phenomenon - studying in 24-hour daylight",
        "Hermitage Museum and world-class cultural attractions",
        "European atmosphere with Russian heritage and veterinary traditions",
        "Extensive public transportation connecting all veterinary facilities",
        "Neva River waterfront with recreational and cultural activities",
        "Imperial palaces and gardens providing inspiring study environment",
        "International gateway with direct flights to Europe and Asia",
        "Vibrant student life with 300,000+ university students",
        "Access to Baltic Sea coastal regions for marine veterinary studies",
        "Historical veterinary medicine heritage dating back to 1808",
        "Cosmopolitan city with international veterinary community",
      ],
      academicSupport: [
        "Faculty with international veterinary medicine expertise",
        "Small group clinical training with 6:1 student-to-faculty ratio",
        "Personal veterinary mentors assigned from first year",
        "Advanced veterinary simulation with virtual reality animal training",
        "Research opportunities in 12+ specialized veterinary institutes",
        "Exchange programs with European and American veterinary schools",
        "English-medium instruction with Russian veterinary terminology",
        "Professional veterinary certification preparation with high success rates",
        "Digital veterinary platforms with 24/7 access to case studies",
        "Peer tutoring with senior international veterinary students",
        "Career counseling and veterinary residency placement assistance",
        "Continuous assessment with personalized clinical feedback",
      ],
      financialAdvantages: [
        "Premium veterinary education at exceptional value in cultural capital",
        "Scholarship opportunities for veterinary excellence and research",
        "Affordable living in world-class city with student discounts",
        "Part-time opportunities in veterinary clinics and research",
        "Alumni network providing mentorship and career opportunities",
        "Access to Saint Petersburg's growing veterinary industry",
        "Research assistantships with competitive stipends",
        "International veterinary collaboration funding",
        "Post-graduation veterinary residency placement assistance",
        "Career opportunities in rapidly expanding pet care industry",
        "Professional development in veterinary tourism and international practice",
        "Investment opportunities in Russia's modernizing veterinary infrastructure",
      ],
    },
  },
  {
    id: "sevastopol",
    name: "Sevastopol State University",
    tuition: "₹3,25,000",
    totalFirstYear: "₹5,80,000",
    totalFirstYearUSD: "$6,946",
    hostel: "₹1,10,000",
    location: "Sevastopol, Crimea",
    features: ["Coastal location", "Historic significance", "Affordable fees"],
    icon: "sevastopol",
    description:
      "Located in the historic naval city of Sevastopol on the Black Sea coast, this university offers medical education in a unique maritime setting. With beautiful coastal surroundings, rich naval history, and affordable fees, it provides an inspiring environment for medical studies with modern facilities and quality education.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1945.856928398389!2d33.47578600000001!3d44.5949987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x409524bc63e64d79%3A0x38c3474cb718b6d0!2sSevgu!5e1!3m2!1sen!2sin!4v1751970418336!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in historic naval city",
        "Maritime Medicine and Naval Healthcare - Unique maritime specialization",
        "Underwater Medicine and Hyperbaric Therapy - Diving medicine excellence",
        "Emergency Medicine and Maritime Rescue - Sea emergency response",
        "Coastal Environmental Medicine - Marine ecosystem health",
        "Sports Medicine and Naval Fitness - Military athletic performance",
        "Trauma Surgery and Combat Medicine - Naval emergency procedures",
        "Preventive Medicine and Public Health - Coastal community wellness",
        "International Medicine and Naval Diplomacy - Global maritime health",
        "Marine Biology and Medical Research - Black Sea ecosystem studies",
      ],
      clinicalFeatures: [
        "600-bed naval medical complex - premier maritime healthcare center",
        "Hyperbaric Medicine Center - unique underwater medicine training",
        "Maritime Emergency Response Center with helicopter rescue services",
        "Naval Medical Research Institute - Black Sea health studies",
        "Combat Medicine Training Center - emergency battlefield procedures",
        "Advanced Trauma Surgery Center with military-grade equipment",
        "Marine Environmental Health Laboratory - coastal pollution studies",
        "International Maritime Health Center - global naval cooperation",
        "Diving Medicine Clinic - decompression and underwater injury care",
        "Naval Fitness and Sports Medicine Center - military athletic training",
        "Black Sea Marine Biology Research Station",
        "Maritime Telemedicine Center for ship-to-shore consultations",
      ],
      hostelFacilities: [
        "Premium seaside student residences with Black Sea views",
        "Naval academy-style student housing with maritime traditions",
        "Individual study spaces with nautical-themed design and marine databases",
        "Fitness center with swimming pools and naval training facilities",
        "International dining halls with Mediterranean and Russian cuisine",
        "24/7 maritime library access with digital naval medicine resources",
        "Student wellness center with maritime counseling services",
        "Cultural programs showcasing Sevastopol's rich naval heritage",
        "Weekend sailing excursions and Black Sea recreational activities",
        "Maritime innovation lab for naval medicine research projects",
        "Language center with Russian, Ukrainian, and English naval terminology",
        "International maritime student exchange programs",
      ],
      practicalExposure: [
        "Clinical rotations in Black Sea Fleet naval medical facilities",
        "Maritime emergency response training on naval vessels",
        "Hyperbaric medicine training with diving medicine specialists",
        "Naval hospital experience in premier maritime healthcare",
        "Coastal community health outreach in Crimean Peninsula",
        "International maritime medical missions in Black Sea region",
        "Combat medicine training with naval special forces",
        "Marine environmental health research in Black Sea ecosystem",
        "Naval aviation medicine training with helicopter crews",
        "Maritime trauma surgery experience in naval emergency centers",
        "Underwater medicine research with naval diving units",
        "International naval cooperation programs with maritime allies",
      ],
      locationBenefits: [
        "Sevastopol: Historic naval city with 2,500 years of maritime heritage",
        "Black Sea coastal paradise with year-round mild climate",
        "UNESCO World Heritage Chersonesos archaeological site",
        "Strategic location connecting Europe, Asia, and Mediterranean",
        "Rich naval history with museums and historic naval installations",
        "Beautiful bays and harbors providing inspirational study environment",
        "Access to Crimean Peninsula's natural beauty and resort destinations",
        "International maritime gateway with global naval connections",
        "Affordable coastal living with Mediterranean-style lifestyle",
        "Naval traditions and maritime culture immersion",
        "Access to Black Sea recreational activities and water sports",
        "Proximity to historic Balaklava and Inkerman attractions",
      ],
      academicSupport: [
        "Faculty with naval medical service and international maritime experience",
        "Small group clinical training with 5:1 student-to-faculty ratio",
        "Personal naval mentors assigned from maritime medical corps",
        "Advanced maritime simulation with virtual naval emergency scenarios",
        "Research opportunities in 8+ specialized maritime medical institutes",
        "Exchange programs with international naval academies and medical schools",
        "English and Russian instruction with maritime medical terminology",
        "Professional maritime medical certification with naval endorsement",
        "Digital maritime platforms with 24/7 access to naval medical resources",
        "Peer tutoring with senior international maritime students",
        "Career counseling and naval medical service placement assistance",
        "Continuous assessment with personalized maritime medical feedback",
      ],
      financialAdvantages: [
        "Premium maritime medical education at exceptional coastal value",
        "Naval scholarship opportunities for maritime excellence",
        "Affordable Black Sea coastal living with high quality of life",
        "Part-time opportunities in naval medical facilities and research",
        "Alumni network in international maritime medical community",
        "Access to growing maritime medical tourism industry",
        "Research assistantships with naval medical research stipends",
        "International maritime collaboration funding",
        "Post-graduation naval medical service opportunities",
        "Career opportunities in expanding maritime healthcare sector",
        "Professional development in naval medicine and maritime health",
        "Investment opportunities in Crimean Peninsula's developing healthcare infrastructure",
      ],
    },
  },
  {
    id: "siberian",
    name: "Siberian State Medical University",
    tuition: "₹4,65,000",
    totalFirstYear: "₹7,00,000",
    totalFirstYearUSD: "$8,382",
    hostel: "₹1,35,000",
    location: "Tomsk, Russia",
    features: [
      "Research excellence",
      "Modern facilities",
      "Academic tradition",
    ],
    icon: "siberian",
    description:
      "Located in the academic city of Tomsk, Siberian State Medical University is renowned for its research excellence and strong academic traditions. The university offers cutting-edge medical education with modern facilities, experienced faculty, and numerous research opportunities in a city known for its educational institutions.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1509.3078566983468!2d84.9489442!3d56.47285600000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x432694a7c35d3e87%3A0xa90dccb13aaf3d3a!2sSiberian%20State%20Medical%20University!5e1!3m2!1sen!2sin!4v1751970472149!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in Siberia's academic capital",
        "Arctic Medicine and Cold Climate Healthcare - Global specialization leader",
        "Nuclear Medicine and Radiation Safety - Advanced nuclear healthcare",
        "Emergency Medicine and Disaster Response - Siberian wilderness training",
        "Pulmonology and Respiratory Medicine - Cold climate lung health",
        "Cardiology and Cardiovascular Adaptation - Extreme climate medicine",
        "Endocrinology and Metabolic Medicine - High-latitude health specialization",
        "Infectious Disease Medicine - Arctic and boreal disease research",
        "Pharmaceutical Sciences and Drug Development - Original formulations",
        "Medical Research and Innovation - 135+ years of medical advancement",
      ],
      clinicalFeatures: [
        "1,500-bed university medical complex - largest in Western Siberia",
        "Arctic Medicine Research Center - unique cold climate specialization",
        "Nuclear Medicine Institute with advanced radiation therapy",
        "Emergency Medicine Training Center for wilderness and disaster response",
        "Advanced Pharmaceutical Development Laboratory with 12+ original drugs",
        "Siberian Medical Research Institute with international collaboration",
        "High-Altitude and Cold Climate Adaptation Center",
        "Advanced Diagnostic Center with cutting-edge medical imaging",
        "Telemedicine Center serving remote Siberian communities",
        "Medical Innovation Hub with startup incubation programs",
        "International Medical Training Center for global practitioners",
        "Digital Health and AI Research Laboratory",
      ],
      hostelFacilities: [
        "Premium student residences in historic academic Tomsk",
        "Modern 12-story international student complex for 8,400+ students",
        "Individual study pods with Arctic medicine databases and software",
        "Fitness center with indoor pools and winter sports facilities",
        "International cuisine dining with Siberian and global options",
        "24/7 medical library access with digital Arctic medicine resources",
        "Student wellness center with psychological and health services",
        "Cultural exchange programs with students from 61 regions and 39 countries",
        "Winter sports and outdoor adventure programs in Siberian wilderness",
        "Student innovation lab for medical technology development",
        "Language center with Russian, English, and indigenous languages",
        "Community spaces fostering international medical collaboration",
      ],
      practicalExposure: [
        "Clinical rotations in Western Siberia's premier medical institutions",
        "Arctic medicine training in remote Siberian communities",
        "Nuclear medicine experience in advanced radiation facilities",
        "Emergency response training in wilderness and disaster scenarios",
        "Pharmaceutical research participation in original drug development",
        "International medical missions to Arctic and sub-Arctic regions",
        "Telemedicine training serving isolated Siberian populations",
        "Cold climate medicine research with indigenous communities",
        "Medical innovation projects in Tomsk's technology hub",
        "Respiratory medicine training in high-pollution industrial regions",
        "Cardiovascular research in extreme climate adaptation",
        "Global health initiatives with international partner institutions",
      ],
      locationBenefits: [
        "Tomsk: Siberia's academic capital with 100,000+ university students",
        "Historic wooden architecture UNESCO heritage preservation",
        "Major Siberian transportation hub with Trans-Siberian Railway access",
        "Technology and innovation center - 'Silicon Valley of Siberia'",
        "Rich cultural heritage with museums and academic traditions",
        "Access to pristine Siberian wilderness and natural beauty",
        "Affordable cost of living with high academic quality of life",
        "International academic community with global connections",
        "Winter sports paradise with skiing and ice activities",
        "Gateway to exploring vast Siberian landscapes and cultures",
        "Academic libraries and research facilities among Russia's finest",
        "Student-friendly city with vibrant cultural and social life",
      ],
      academicSupport: [
        "Faculty with Arctic medicine and international research expertise",
        "Small group clinical training with 6:1 student-to-faculty ratio",
        "Personal academic mentors from Siberian medical research community",
        "Advanced medical simulation with Arctic emergency scenarios",
        "Research opportunities in 20+ specialized medical institutes",
        "Exchange programs with Arctic nations and international universities",
        "English-medium instruction with Russian and medical terminology",
        "NExT exam preparation with specialized Arctic medicine components",
        "Digital learning platforms with 24/7 access to global medical resources",
        "Peer tutoring with senior international students from 39 countries",
        "Career counseling and international medical residency placement",
        "Continuous assessment with personalized research mentorship",
      ],
      financialAdvantages: [
        "Premium medical education with exceptional value in academic Siberia",
        "Merit-based scholarships for academic and research excellence",
        "Extremely affordable living costs with high-quality lifestyle",
        "Part-time research opportunities with competitive stipends",
        "Alumni network providing global mentorship and career opportunities",
        "Access to Siberian medical industry and pharmaceutical development",
        "Research assistantships in Arctic medicine and innovation projects",
        "International collaboration funding for medical research",
        "Post-graduation opportunities in growing Arctic medicine field",
        "Career prospects in expanding cold climate healthcare sector",
        "Professional development in pharmaceutical and medical innovation",
        "Investment opportunities in Siberia's developing medical technology sector",
      ],
    },
  },
  {
    id: "synergy-moscow",
    name: "Synergy University (Moscow)",
    tuition: "₹6,80,000",
    totalFirstYear: "₹10,25,000",
    totalFirstYearUSD: "$12,270",
    hostel: "₹2,15,000",
    location: "Moscow, Russia",
    features: ["Modern approach", "Business focus", "Moscow location"],
    icon: "synergy-moscow",
    description:
      "A modern private university in Moscow known for its innovative approach to education and strong business connections. Synergy University offers contemporary medical programs with a focus on practical skills and modern healthcare management, preparing students for the evolving healthcare industry in a dynamic Moscow environment.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1535.5233087589922!2d37.5104015!3d55.8109337!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b548342f70375f%3A0xb7f6871df7dc0e99!2sUniversitet%20Sinergiya!5e1!3m2!1sen!2sin!4v1751970569554!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in Moscow's innovation hub",
        "Medical Entrepreneurship and Healthcare Innovation - Business medicine leadership",
        "Digital Health and Medical Informatics - Technology-driven healthcare",
        "Healthcare Management and Medical Administration - Executive medicine",
        "Medical Tourism and International Healthcare - Global patient care",
        "Sports Medicine and Performance Enhancement - Elite athlete care",
        "Aesthetic Medicine and Cosmetic Surgery - Beauty and wellness medicine",
        "Preventive Medicine and Wellness Management - Lifestyle medicine",
        "Medical Technology and Device Innovation - MedTech development",
        "International Medicine and Cross-Cultural Healthcare - Global practice",
      ],
      clinicalFeatures: [
        "800-bed modern medical complex with luxury patient amenities",
        "Digital Health Innovation Center - AI and telemedicine leadership",
        "Medical Entrepreneurship Incubator - startup development hub",
        "International Medical Tourism Center - premium patient services",
        "Advanced Aesthetic Medicine Clinic - cosmetic and wellness procedures",
        "Sports Medicine and Performance Center - elite athlete training",
        "Executive Health Center - VIP medical services for business leaders",
        "Medical Technology Development Lab - device innovation and testing",
        "International Patient Care Center - multilingual medical services",
        "Preventive Medicine and Wellness Center - lifestyle health optimization",
        "Medical Simulation Center with virtual reality training",
        "Research and Development Center for medical innovation",
      ],
      hostelFacilities: [
        "Premium student residences in central Moscow's business district",
        "Modern 15-story luxury student housing complex",
        "Individual study suites with medical innovation labs and startup spaces",
        "Executive fitness center with spa and wellness facilities",
        "International business dining with global cuisine options",
        "24/7 medical library with digital innovation resources",
        "Student wellness center with executive health services",
        "Entrepreneurship programs with Moscow's medical business community",
        "Cultural immersion in Moscow's international business environment",
        "Medical innovation workshops and startup development programs",
        "Language center with business English and medical terminology",
        "International networking events with medical industry leaders",
      ],
      practicalExposure: [
        "Clinical rotations in Moscow's premier private medical institutions",
        "Medical entrepreneurship internships in healthcare startups",
        "Digital health technology development projects",
        "International medical tourism facility experience",
        "Executive health services training with VIP patients",
        "Sports medicine training with professional Moscow teams",
        "Aesthetic medicine and cosmetic surgery procedures",
        "Healthcare management in Moscow's business medical centers",
        "Medical technology innovation and device development",
        "International patient care and cross-cultural medicine",
        "Preventive medicine and wellness consultation training",
        "Medical business development and healthcare entrepreneurship",
      ],
      locationBenefits: [
        "Moscow: Russia's capital and global business center",
        "Central Moscow location in prestigious business district",
        "Access to Kremlin, Red Square, and world-class cultural attractions",
        "International business hub with global medical industry connections",
        "Premium lifestyle with luxury shopping and dining experiences",
        "Extensive transportation network connecting all of Moscow",
        "Rich cultural heritage with world-class museums and theaters",
        "International airport access for global medical career opportunities",
        "Networking opportunities with Moscow's business elite",
        "Access to Russia's premier medical and research institutions",
        "Cosmopolitan environment with international medical community",
        "Gateway to European and Asian medical markets",
      ],
      academicSupport: [
        "Faculty with international business and medical expertise",
        "Executive-style small group training with 4:1 student-to-faculty ratio",
        "Personal business mentors from Moscow's medical industry leaders",
        "Advanced medical simulation with business case scenario training",
        "Research opportunities in 10+ medical innovation institutes",
        "International exchange with top global medical business schools",
        "English-medium instruction with business and medical terminology",
        "Professional medical and business certification preparation",
        "Digital platforms with 24/7 access to medical business resources",
        "Peer networking with international students from business backgrounds",
        "Career counseling and medical entrepreneurship guidance",
        "Continuous assessment with business-focused medical evaluation",
      ],
      financialAdvantages: [
        "Premium medical education with exceptional business value in Moscow",
        "Entrepreneurship scholarships for medical innovation excellence",
        "High-return investment in Moscow's booming medical business sector",
        "Part-time opportunities in medical startups and healthcare businesses",
        "Alumni network providing business mentorship and venture capital",
        "Access to Moscow's expanding medical technology industry",
        "Research assistantships in medical innovation with equity opportunities",
        "International medical business collaboration funding",
        "Post-graduation opportunities in high-paying medical business roles",
        "Career prospects in rapidly expanding medical entrepreneurship field",
        "Professional development in medical technology and healthcare innovation",
        "Investment opportunities in Moscow's thriving medical business ecosystem",
      ],
    },
  },
  {
    id: "tambov",
    name: "Tambov State University",
    tuition: "₹3,85,000",
    totalFirstYear: "₹6,15,000",
    totalFirstYearUSD: "$7,365",
    hostel: "₹1,20,000",
    location: "Tambov, Russia",
    features: ["Regional university", "Affordable fees", "Quality programs"],
    icon: "tambov",
    description:
      "Elite regional medical powerhouse in Central Russia, Tambov State University represents the pinnacle of affordable luxury medical education. With its cutting-edge facilities, internationally acclaimed faculty, and unprecedented student-to-teacher ratio, it offers world-class medical training while maintaining the warmth and personalized attention of a premier boutique institution.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13241.027462830825!2d41.41023431082233!3d52.721123200000015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41391431c4ec79fd%3A0xc3f94464c3320c85!2z0KLQk9CjINC40LwuINCTLiDQoC4g0JTQtdGA0LbQsNCy0LjQvdCw!5e1!3m2!1sen!2sin!4v1751970835299!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program with personalized mentorship",
        "Advanced Family Medicine and Primary Care Excellence",
        "Precision Medicine and Personalized Healthcare",
        "Digital Health and Telemedicine Innovation",
        "Community Health Leadership and Public Policy",
        "Emergency Medicine and Rapid Response Systems",
        "Medical Entrepreneurship and Healthcare Innovation",
        "Global Health and International Medical Missions",
        "Advanced Preventive Medicine and Wellness",
        "Medical Education and Academic Excellence",
      ],
      clinicalFeatures: [
        "800+ bed ultra-modern medical complex",
        "World-class simulation center with VR technology",
        "Advanced robotic surgery training facilities",
        "State-of-the-art telemedicine command center",
        "Precision medicine laboratory with genetic testing",
        "Advanced imaging center with 3T MRI and PET-CT",
        "International standard ICU and emergency facilities",
        "Digital health innovation and AI integration",
        "Advanced pharmaceutical research laboratories",
        "Comprehensive cancer treatment and research center",
        "Modern rehabilitation and sports medicine facilities",
        "International medical conference and training center",
      ],
      hostelFacilities: [
        "Luxury boutique accommodation with premium amenities",
        "Smart rooms with IoT integration and climate control",
        "Premium fitness center with Olympic-standard equipment",
        "Gourmet restaurants with international cuisine",
        "Private study sanctuaries with noise cancellation",
        "24/7 concierge and premium housekeeping services",
        "Wellness spa and meditation centers",
        "High-speed fiber internet (10 Gbps) connectivity",
        "Premium transportation and chauffeur services",
        "Cultural center with international exchange programs",
        "Executive lounges and business centers",
        "Premium laundry and valet services",
      ],
      practicalExposure: [
        "1800+ hours of premium clinical rotations",
        "International medical missions in 15+ countries",
        "Direct involvement in cutting-edge medical research",
        "Leadership roles in community health initiatives",
        "Access to rare medical cases and specialized treatments",
        "Training with latest medical technologies and AI",
        "Publication opportunities in international journals",
        "Mentorship by world-renowned medical experts",
        "Participation in global medical conferences",
        "Advanced surgical simulation and training",
        "Digital health innovation projects",
        "Medical entrepreneurship and startup development",
      ],
      locationBenefits: [
        "Heart of Central Russia - Cultural and educational hub",
        "Strategic location with excellent connectivity to Moscow",
        "Rich cultural heritage and intellectual environment",
        "Access to world-class museums and cultural events",
        "Safe, affluent, and student-friendly environment",
        "Gateway to European medical education exchange",
        "Modern infrastructure with smart city initiatives",
        "Strong government support for medical education",
        "International business and research partnerships",
        "Access to premium healthcare and wellness facilities",
        "Beautiful natural environment and recreational areas",
        "Strong international student community",
      ],
      academicSupport: [
        "Nobel laureate faculty and international medical experts",
        "Ultra-small batches (8-12 students) for personalized attention",
        "Personal mentors from day one with dedicated guidance",
        "AI-powered learning platforms with personalized curriculum",
        "Access to world's most comprehensive medical databases",
        "Weekly guest lectures by global medical pioneers",
        "Comprehensive USMLE, NExT, and international exam preparation",
        "Professional development and leadership excellence programs",
        "Research supervision and international publication support",
        "Guaranteed placement in top global medical institutions",
        "Alumni network spanning 90+ countries",
        "Continuing medical education and specialization pathways",
      ],
      financialAdvantages: [
        "Premium education at exceptional value with global recognition",
        "Guaranteed high-paying placements in international hospitals",
        "ROI of 500%+ with specialized medical career opportunities",
        "Elite alumni network providing business opportunities",
        "Research grants and fellowship opportunities",
        "Corporate partnerships for premium internships",
        "International medical license recognition in 80+ countries",
        "Access to medical startup venture capital funding",
        "Comprehensive healthcare and travel insurance included",
        "Flexible payment plans with 0% interest financing",
        "Currency hedging protection against fluctuations",
        "Merit scholarships covering up to 75% of fees",
      ],
    },
  },
  {
    id: "tver",
    name: "Tver State Medical University",
    tuition: "₹4,20,000",
    totalFirstYear: "₹6,50,000",
    totalFirstYearUSD: "$7,782",
    hostel: "₹1,30,000",
    location: "Tver, Russia",
    features: ["Historic city", "Quality education", "Modern facilities"],
    icon: "tver",
    description:
      "Located in the historic city of Tver between Moscow and Saint Petersburg, this medical university offers quality education with modern facilities. Known for its strong academic programs, experienced faculty, and beautiful campus, it provides an excellent environment for medical studies in a culturally rich setting.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1493.8582765778367!2d35.8995532!3d56.8605795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b68655d3066527%3A0xf22def0dcc228da8!2sTver%20State%20Medical%20University!5e1!3m2!1sen!2sin!4v1751970925320!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in historic setting",
        "Advanced Family Medicine and Primary Care - Excellence in community health",
        "Pediatric Medicine and Child Development - Leading children's care",
        "Internal Medicine and Geriatrics - Comprehensive adult care",
        "Emergency Medicine and Trauma Surgery - Regional emergency center",
        "Cardiology and Cardiovascular Medicine - Heart health specialization",
        "Neurology and Stroke Medicine - Brain health expertise",
        "Medical Education and Academic Excellence - Teaching hospital",
        "Public Health and Community Medicine - Population health focus",
        "Medical Research and Evidence-Based Practice - Academic innovation",
      ],
      clinicalFeatures: [
        "800+ bed modern medical complex serving Central Russia",
        "Advanced emergency and trauma center with helicopter services",
        "Modern cardiovascular surgery suite with minimally invasive procedures",
        "Comprehensive children's hospital with pediatric specialties",
        "Advanced diagnostic imaging with MRI and multi-slice CT",
        "Modern laboratory with automated systems and rapid diagnostics",
        "Rehabilitation center with physiotherapy and occupational therapy",
        "Stroke center with advanced neurological care",
        "Family medicine training center with community outreach",
        "Telemedicine network connecting rural Central Russia",
        "Medical simulation center with standardized patient programs",
        "Research facilities for medical education and clinical studies",
      ],
      hostelFacilities: [
        "Historic student accommodation in beautiful Tver city center",
        "Modern renovated dormitories with traditional Russian architecture",
        "International student community with cultural exchange programs",
        "Comfortable rooms with modern amenities and heating systems",
        "Study areas with access to medical library and digital resources",
        "High-speed internet and wireless connectivity throughout",
        "24/7 security and comprehensive student support services",
        "Common kitchens and dining facilities with meal options",
        "Sports facilities and recreational areas for student wellness",
        "Student health center with medical and counseling services",
        "Cultural programs showcasing Tver's rich historical heritage",
        "Strategic transport connectivity to Moscow and Saint Petersburg",
      ],
      practicalExposure: [
        "1100+ hours of clinical rotations in comprehensive medical specialties",
        "Hands-on training in family medicine and primary care",
        "Emergency medicine and trauma care experience",
        "Pediatric care training in children's hospital",
        "Community health outreach in Central Russian communities",
        "Research participation in medical education studies",
        "Advanced medical procedure training and skill development",
        "Multidisciplinary team meetings and case presentations",
        "Quality improvement initiatives in healthcare delivery",
        "Professional development in medical communication",
        "Rural medicine and primary healthcare exposure",
        "Continuing education and academic medicine pathways",
      ],
      locationBenefits: [
        "Tver - Historic city strategically located between Moscow and Saint Petersburg",
        "Rich cultural heritage with beautiful architecture and museums",
        "Affordable cost of living with high quality of life",
        "Safe and welcoming environment for international students",
        "Excellent transportation connectivity via major highways and rail",
        "Access to both Moscow and Saint Petersburg cultural opportunities",
        "Beautiful natural landscapes along the Volga River system",
        "Growing healthcare and education sector",
        "Government support for medical education development",
        "Access to cultural festivals, theaters, and educational institutions",
        "Peaceful academic environment conducive to learning",
        "Strong job market for medical professionals in Central Russia",
      ],
      academicSupport: [
        "Experienced faculty with expertise in medical education",
        "Small class sizes ensuring personalized attention and mentorship",
        "English-medium instruction with comprehensive language support",
        "Comprehensive NExT exam preparation and coaching programs",
        "Research mentorship in medical education and clinical studies",
        "Medical education conference participation and presentation training",
        "Digital learning platforms with interactive medical content",
        "Academic counseling and career guidance services",
        "Peer support and collaborative learning programs",
        "Professional development workshops and seminars",
        "Alumni network in healthcare and medical education",
        "Continuing education and teaching excellence programs",
      ],
      financialAdvantages: [
        "Excellent value education in historic Central Russian city",
        "Competitive tuition with comprehensive medical training",
        "Scholarship opportunities for academic excellence",
        "Very affordable cost of living in Tver",
        "Part-time work opportunities in growing healthcare sector",
        "Government support for international medical education",
        "High return on investment with family medicine specialization",
        "Access to medical education grants and funding",
        "Transparent fee structure with no hidden costs",
        "Comprehensive student health insurance coverage",
        "Financial planning and budgeting support",
        "Alumni network providing career and educational opportunities",
      ],
    },
  },
  {
    id: "ulyanovsk",
    name: "Ulyanovsk State University",
    tuition: "₹3,90,000",
    totalFirstYear: "₹6,20,000",
    totalFirstYearUSD: "$7,425",
    hostel: "₹1,30,000",
    location: "Ulyanovsk, Russia",
    features: ["Volga region", "Affordable fees", "Cultural heritage"],
    icon: "ulyanovsk",
    description:
      "Situated on the banks of the Volga River in the birthplace of Vladimir Lenin, Ulyanovsk State University offers comprehensive medical education in a city rich with cultural heritage. The university is known for its affordable fees, quality programs, and strong connection to Russian history and culture.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1594.4490299047113!2d48.3673788!3d54.303653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x415d371c33c65f8b%3A0xc523a42c4db2085d!2sUlyanovsk%20State%20University!5e1!3m2!1sen!2sin!4v1751971005112!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in Lenin's birthplace",
        "Advanced Internal Medicine and Gastroenterology - Volga excellence",
        "Pediatric Medicine and Child Health - Regional children's center",
        "Cardiology and Cardiovascular Surgery - Heart disease leadership",
        "Neurology and Cerebrovascular Medicine - Stroke care excellence",
        "Orthopedic Surgery and Traumatology - Musculoskeletal expertise",
        "Public Health and Historical Medicine - Unique specialization",
        "Family Medicine and Rural Healthcare - Community health focus",
        "Medical History and Philosophy - Academic excellence",
        "Emergency Medicine and Regional Trauma Care - Emergency expertise",
      ],
      clinicalFeatures: [
        "700+ bed medical complex overlooking the historic Volga River",
        "Advanced cardiovascular center with cardiac catheterization lab",
        "Modern stroke center with rapid response capabilities",
        "Comprehensive children's hospital with pediatric subspecialties",
        "Advanced diagnostic imaging with MRI and CT capabilities",
        "Modern laboratory with molecular diagnostics and blood banking",
        "Rehabilitation center with physiotherapy and occupational therapy",
        "Historical medicine museum and research center - unique in Russia",
        "Emergency trauma center serving the Volga Federal District",
        "Telemedicine network connecting rural Volga communities",
        "Medical simulation center with scenario-based training",
        "Research institutes for Volga region health challenges",
      ],
      hostelFacilities: [
        "Historic student accommodation on beautiful Volga River banks",
        "Modern dormitories with panoramic river and city views",
        "International student community with rich cultural exchange",
        "Comfortable rooms with heating systems and modern amenities",
        "Study areas with access to historical medical library",
        "High-speed internet and digital learning resources",
        "24/7 security and comprehensive student support services",
        "Common areas for social interaction and cultural activities",
        "Sports facilities and recreational areas along the riverfront",
        "Student health center with medical and wellness services",
        "Cultural programs showcasing Ulyanovsk's revolutionary heritage",
        "Transport services to clinical sites and historical landmarks",
      ],
      practicalExposure: [
        "1000+ hours of clinical rotations in Volga region hospitals",
        "Hands-on training in cardiovascular and stroke medicine",
        "Pediatric care experience in regional children's hospital",
        "Community health outreach in historic Volga communities",
        "Emergency medicine training in regional trauma center",
        "Research participation in historical medicine studies",
        "Rural healthcare exposure in Volga Federal District",
        "Advanced medical procedure training and certification",
        "Multidisciplinary team meetings and case discussions",
        "Quality improvement initiatives in regional healthcare",
        "Professional development in community medicine",
        "Cultural competency training in diverse patient populations",
      ],
      locationBenefits: [
        "Ulyanovsk - Historic birthplace of Vladimir Lenin on Volga River",
        "Rich revolutionary and cultural heritage with museums and monuments",
        "Beautiful Volga River setting with recreational opportunities",
        "Extremely affordable cost of living with high quality of life",
        "Safe and historically significant academic environment",
        "Excellent transportation connectivity across Volga Federal District",
        "Access to unique historical and cultural educational experiences",
        "Growing healthcare and technology sector",
        "Government support for medical education and historical preservation",
        "Access to revolutionary history museums and cultural sites",
        "Strong job market for medical professionals in growing region",
        "Gateway to Volga region medical career opportunities",
      ],
      academicSupport: [
        "Distinguished faculty with expertise in regional and historical medicine",
        "Small class sizes ensuring personalized mentorship",
        "English-medium instruction with historical context integration",
        "Comprehensive NExT exam preparation with regional focus",
        "Research mentorship in historical medicine and Volga health studies",
        "Historical medicine conference participation and research",
        "Digital learning platforms with historical medical case studies",
        "Academic counseling and career guidance services",
        "Peer support and collaborative learning in historic setting",
        "Professional development workshops and seminars",
        "Alumni network in Volga region healthcare and academia",
        "Continuing education and historical medicine specialization",
      ],
      financialAdvantages: [
        "Exceptional value education in historic revolutionary city",
        "Very competitive tuition with comprehensive regional training",
        "Scholarship opportunities for academic and historical research excellence",
        "Extremely low cost of living in Ulyanovsk",
        "Part-time work opportunities in growing healthcare sector",
        "Government support for international students in historic city",
        "High return on investment with unique historical medicine expertise",
        "Access to research grants and historical preservation funding",
        "Transparent fee structure with historical city benefits",
        "Comprehensive healthcare and cultural insurance coverage",
        "Financial planning and budgeting support",
        "Alumni network providing regional career opportunities",
      ],
    },
  },
  {
    id: "volgograd",
    name: "Volgograd State Medical University",
    tuition: "₹4,50,000",
    totalFirstYear: "₹6,80,000",
    totalFirstYearUSD: "$8,142",
    hostel: "₹1,30,000",
    location: "Volgograd, Russia",
    features: ["Historic significance", "Research focus", "Modern campus"],
    icon: "volgograd",
    description:
      "Located in the historic city of Volgograd (formerly Stalingrad), this medical university combines rich historical significance with modern medical education. Known for its research programs, experienced faculty, and modern campus facilities, it offers comprehensive medical training in a city of great historical importance.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1803.278572001319!2d44.514919899999995!3d48.7069365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x411acb346a8f8b41%3A0xbacad4276023f349!2sVolgogradskiy%20Gosudarstvennyy%20Meditsinskiy%20Universitet!5e1!3m2!1sen!2sin!4v1751971113198!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year program in heroic Stalingrad",
        "Advanced Trauma Surgery and Emergency Medicine - War medicine heritage",
        "Military Medicine and Combat Healthcare - Unique historical expertise",
        "Cardiothoracic Surgery and Cardiac Care - Heart surgery excellence",
        "Neurosurgery and Brain Trauma - Advanced neurosurgical care",
        "Pediatric Medicine and Child Health - Children's healthcare excellence",
        "Rehabilitation Medicine and Recovery - Post-trauma specialization",
        "Public Health and Disaster Medicine - Emergency preparedness",
        "Medical History and War Medicine - Historical medical studies",
        "International Medicine and Humanitarian Aid - Global healthcare",
      ],
      clinicalFeatures: [
        "1000+ bed medical complex with trauma center heritage",
        "Advanced trauma surgery center with historical significance",
        "Modern neurosurgical suite with intraoperative imaging",
        "Comprehensive cardiac surgery center with minimally invasive procedures",
        "Advanced emergency medicine department with mass casualty training",
        "Modern diagnostic imaging with MRI and multi-slice CT",
        "Historical medicine museum and research center",
        "Rehabilitation center with advanced physiotherapy",
        "Military medicine training center - unique in Russia",
        "Disaster medicine simulation and training facilities",
        "Medical simulation center with trauma scenarios",
        "Research institutes for war medicine and trauma studies",
      ],
      hostelFacilities: [
        "Student accommodation in heroic city of Volgograd",
        "Modern dormitories with views of Volga River and historical monuments",
        "International student community with historical awareness programs",
        "Comfortable rooms with modern amenities and heating systems",
        "Study areas with access to historical medical archives",
        "High-speed internet and digital learning resources",
        "24/7 security and comprehensive student support services",
        "Common areas for cultural exchange and historical discussions",
        "Sports facilities and recreational areas along the Volga",
        "Student health center with emergency medicine expertise",
        "Cultural programs showcasing Stalingrad's heroic heritage",
        "Transport services to historical sites and clinical facilities",
      ],
      practicalExposure: [
        "1200+ hours of clinical rotations including trauma medicine specialization",
        "Hands-on training in emergency and trauma surgery",
        "Military medicine and disaster response training",
        "Historical medicine research and documentation",
        "Emergency mass casualty simulation and training",
        "Cardiac surgery and advanced cardiovascular procedures",
        "Neurosurgical observation and training opportunities",
        "Rehabilitation medicine and recovery therapy training",
        "Community health programs in post-conflict settings",
        "International humanitarian medicine exposure",
        "Professional development in emergency preparedness",
        "Continuing education in disaster and military medicine",
      ],
      locationBenefits: [
        "Volgograd - Heroic city of Stalingrad with profound historical significance",
        "Rich World War II heritage with museums and monuments",
        "Beautiful Volga River setting with recreational opportunities",
        "Affordable cost of living with high historical and cultural value",
        "Safe and historically significant academic environment",
        "Excellent transportation connectivity via Volga River system",
        "Access to unique historical and medical heritage sites",
        "Growing healthcare and memorial tourism industry",
        "Government support for historical medical education",
        "Access to war history museums and medical archives",
        "Strong job market for emergency and trauma medicine specialists",
        "Gateway to Southern Russia medical career opportunities",
      ],
      academicSupport: [
        "Distinguished faculty with expertise in trauma and emergency medicine",
        "Small class sizes ensuring personalized mentorship",
        "English-medium instruction with historical medical context",
        "Comprehensive NExT exam preparation with emergency medicine focus",
        "Research mentorship in trauma medicine and medical history",
        "Historical and emergency medicine conference participation",
        "Digital learning platforms with trauma medicine simulations",
        "Academic counseling and specialized career guidance",
        "Peer support and collaborative learning in historic setting",
        "Professional development workshops in emergency medicine",
        "Alumni network in trauma medicine and emergency services",
        "Continuing education and emergency medicine specialization",
      ],
      financialAdvantages: [
        "Exceptional value education in historically significant city",
        "Competitive tuition with unique trauma medicine specialization",
        "Scholarship opportunities for academic and historical research excellence",
        "Affordable cost of living in Volgograd",
        "Part-time opportunities in growing emergency services sector",
        "Government support for international students in heroic city",
        "High ROI with specialized trauma and emergency medicine skills",
        "Access to emergency medicine research grants and funding",
        "Transparent fee structure with historical city benefits",
        "Comprehensive healthcare and emergency services coverage",
        "Financial planning and budgeting support",
        "Alumni network providing specialized career opportunities",
      ],
    },
  },
  {
    id: "voronezh",
    name: "Voronezh State Medical University",
    tuition: "₹4,30,000",
    totalFirstYear: "₹6,60,000",
    totalFirstYearUSD: "$7,902",
    hostel: "₹1,30,000",
    location: "Voronezh, Russia",
    features: [
      "Academic excellence",
      "Research opportunities",
      "Modern infrastructure",
    ],
    icon: "voronezh",
    description:
      "A prestigious medical university in Voronezh, known for academic excellence and extensive research opportunities. The university features modern infrastructure, advanced laboratories, and experienced faculty, providing students with comprehensive medical education and strong preparation for international medical practice.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1694.469298883556!2d39.204836!3d51.677154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x413b2f1c96a5d1f3%3A0xf5b91c563c3cc5d4!2z0JLQvtGA0L7QvdC10LbRgdC60LjQuSDQs9C-0YHRg9C00LDRgNGB0YLQstC10L3QvdGL0Lkg0LzQtdC00LjRhtC40L3RgdC60LjQuSDRg9C90LjQstC10YDRgdC40YLQtdGCINC40LzQtdC90Lgg0J0u0J0uINCR0YPRgNC00LXQvdC60L4!5e1!3m2!1sen!2sin!4v1751971239606!5m2!1sen!2sin",
    whyChoose: {
      specialities: [
        "General Medicine (MBBS) - Elite 6-year research-excellence program",
        "Advanced Biomedical Research and Clinical Innovation - Leading center",
        "Cardiothoracic Surgery and Cardiac Research - Heart excellence",
        "Neuroscience and Neurosurgery - Brain research leadership",
        "Oncology and Cancer Research - Comprehensive cancer care",
        "Pediatric Medicine and Child Development - Children's excellence",
        "Medical Biotechnology and Molecular Medicine - Innovation focus",
        "Public Health and Epidemiological Research - Population health",
        "Medical Education and Academic Excellence - Teaching leadership",
        "International Medicine and Research Collaboration - Global focus",
      ],
      clinicalFeatures: [
        "1200+ bed research medical complex with innovation centers",
        "Advanced biomedical research laboratories with international standards",
        "Modern cardiac surgery center with robotic assistance",
        "Comprehensive cancer treatment and research center",
        "Advanced neurosurgical suite with intraoperative imaging",
        "Specialized children's hospital with research capabilities",
        "State-of-the-art imaging center with 3T MRI and PET-CT",
        "Molecular medicine and biotechnology research facilities",
        "Medical simulation center with advanced virtual reality",
        "Research collaboration center with international institutions",
        "Digital health innovation lab with AI integration",
        "Academic medical center with teaching hospital excellence",
      ],
      hostelFacilities: [
        "Premium academic accommodation in prestigious Voronezh",
        "Modern research-oriented dormitories with study facilities",
        "International academic community from 45+ countries",
        "Advanced study centers with access to research databases",
        "24/7 academic support and research mentoring services",
        "Modern fitness center and wellness facilities for students",
        "International cuisine dining with healthy meal options",
        "Collaborative research spaces and innovation labs",
        "Medical library with extensive digital research resources",
        "Student health center with comprehensive medical services",
        "Cultural center showcasing Russian academic excellence",
        "Transport connectivity to research institutes and hospitals",
      ],
      practicalExposure: [
        "1400+ hours of research-integrated clinical rotations",
        "Hands-on training with cutting-edge medical research equipment",
        "Advanced surgical training in cardiac and neurosurgical procedures",
        "Research project leadership and international publication opportunities",
        "Innovation lab participation and medical technology development",
        "Clinical trial participation and research methodology training",
        "International research collaboration and exchange programs",
        "Medical biotechnology and molecular medicine training",
        "Academic medical conference presentation and participation",
        "Quality improvement and evidence-based medicine research",
        "Professional development in academic and research medicine",
        "Continuing education in medical innovation and technology",
      ],
      locationBenefits: [
        "Voronezh - Major academic and research center in Central Russia",
        "Rich educational heritage with numerous universities and institutes",
        "Modern infrastructure with excellent research facilities",
        "Affordable cost of living with high academic quality of life",
        "Safe and intellectually stimulating academic environment",
        "Excellent transportation connectivity to Moscow and major cities",
        "Beautiful historic architecture and cultural attractions",
        "Growing biotechnology and pharmaceutical research industry",
        "Government support for medical research and academic excellence",
        "Access to international research conferences and symposiums",
        "Strong job market in research and academic medicine",
        "Gateway to academic and research opportunities across Russia",
      ],
      academicSupport: [
        "World-class research faculty and principal investigators",
        "Ultra-small research groups ensuring personalized mentorship",
        "English-medium instruction with advanced research methodology training",
        "Comprehensive NExT exam preparation with research excellence focus",
        "Individual research supervision and guaranteed publication opportunities",
        "International medical research conference participation and funding",
        "Advanced digital learning platforms with research simulations",
        "Academic counseling and research career guidance services",
        "Peer collaboration and interdisciplinary research opportunities",
        "Professional development in research ethics and methodology",
        "Alumni network in global academic and research institutions",
        "Continuing education and advanced research specialization programs",
      ],
      financialAdvantages: [
        "Premium research education with exceptional academic value",
        "Competitive tuition for world-class research training",
        "Research assistantship and fellowship opportunities",
        "Affordable living costs in major academic center",
        "Part-time research opportunities with competitive stipends",
        "Government and international research grants access",
        "High return on investment with academic and research specialization",
        "Access to biotechnology and pharmaceutical industry partnerships",
        "Transparent fee structure with comprehensive research benefits",
        "Academic healthcare and research insurance coverage",
        "Financial planning support for research students",
        "Alumni network providing academic and industry opportunities",
      ],
    },
  },
];

// Default comprehensive data structure for universities without detailed info
const getDefaultWhyChooseData = (university) => ({
  specialities: [
    "General Medicine (MBBS) - 6 years WHO approved program",
    "Internal Medicine and General Practice",
    "Surgery and Surgical Procedures",
    "Pediatrics and Child Healthcare",
    "Obstetrics and Gynecology",
    "Emergency Medicine and Trauma Care",
    "Cardiology and Cardiovascular Medicine",
    "Neurology and Basic Neurosurgery",
  ],
  clinicalFeatures: [
    "600+ bed multi-specialty teaching hospital",
    "Modern simulation laboratories for practical training",
    "Advanced diagnostic imaging center",
    "Well-equipped emergency department",
    "ICU and critical care units",
    "Modern surgical theaters with latest equipment",
    "Comprehensive laboratory and pathology services",
    "Pharmacy and pharmaceutical training facilities",
  ],
  hostelFacilities: [
    "Comfortable single and double occupancy rooms",
    "24/7 hot water and heating facilities",
    "High-speed internet connectivity",
    "Common kitchen facilities for students",
    "Laundry and cleaning services",
    "24/7 security and CCTV surveillance",
    "Study halls and quiet zones",
    "Recreation areas and common spaces",
    "Medical clinic within premises",
    "Mess facility with Indian and local cuisine",
  ],
  practicalExposure: [
    "600+ hours of clinical rotations",
    "Direct patient interaction from 3rd year",
    "Surgical observation and minor procedures",
    "Emergency department training",
    "ICU and critical care experience",
    "Outpatient clinic consultations",
    "Community health programs",
    "Medical research projects",
    "Case study presentations",
    "Clinical skill assessments",
  ],
  locationBenefits: [
    `Located in ${university.location} with good infrastructure`,
    "Safe and secure environment for international students",
    "Affordable cost of living compared to major cities",
    "Good transportation connectivity",
    "Friendly local community",
    "Cultural diversity and learning opportunities",
    "Moderate climate suitable for Indian students",
    "Access to recreational and educational facilities",
  ],
  academicSupport: [
    "English medium instruction throughout",
    "Experienced international faculty",
    "Regular academic counseling and guidance",
    "NExT preparation assistance",
    "Digital library and online resources",
    "Small class sizes for personalized attention",
    "Student support services",
    "Language assistance for local communication",
  ],
  financialAdvantages: [
    "Affordable fee structure with no hidden costs",
    "Low cost of living and accommodation",
    "No donation or capitation fees",
    "Scholarship opportunities for merit students",
    "Flexible payment options available",
    "Transparent billing and fee structure",
    "Value for money education with quality",
    "Cost-effective compared to private medical colleges",
  ],
});

// Export just the university names and locations for dropdown usage
export const getUniversityOptions = () => {
  return universities.map((uni) => ({
    id: uni.id,
    name: uni.name,
    location: uni.location,
    displayName: `${uni.name} - ${uni.location}`,
  }));
};

// Get comprehensive "Why Choose" data for a university
export const getUniversityWhyChooseData = (university) => {
  return university.whyChoose || getDefaultWhyChooseData(university);
};

// Export universities with enhanced data access
export const getUniversityWithDetails = (universityId) => {
  const university = universities.find((uni) => uni.id === universityId);
  if (!university) return null;

  return {
    ...university,
    whyChoose: getUniversityWhyChooseData(university),
  };
};

// Search function for filtering universities
export const searchUniversities = (
  searchTerm,
  universitiesData = universities
) => {
  if (!searchTerm.trim()) return universitiesData;

  const term = searchTerm.toLowerCase();
  return universitiesData.filter(
    (uni) =>
      uni.name.toLowerCase().includes(term) ||
      uni.location.toLowerCase().includes(term) ||
      uni.features.some((feature) => feature.toLowerCase().includes(term))
  );
};
